import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, Divider, Grid, Tab, Typography, useTheme, List, ListItem, ListItemText, TableBody, TableContainer, TableHead, Paper, dialogContentTextClasses
 } from '@mui/material';
 import { useParams, useNavigate, useLocation } from 'react-router-dom';
 import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import Header from '../../../components/Header';
import { 
  AlignmentType,
  convertInchesToTwip,
  Document,
  Footer,
  HeadingLevel,
  ImageRun,
  NumberFormat,
  Packer,
  PageOrientation,
  PageNumber,
  Paragraph,
  Table,
  TableCell,
  TableRowProperties,
  TableRow,
  TabStopPosition,
  TextRun, 
  UnderlineType,
  LevelFormat, 
  VerticalAlign,
  TextDirection,
  Underline, 
  BorderStyle,
  Shading,
  ShadingType,
  WidthType,
  SectionType,
} from 'docx';
import { saveAs } from 'file-saver';
import * as fs from "fs";
import { DockSharp } from '@mui/icons-material';
import AssessmentReport from '../Results/AssessmentReportv2';
import GetHelp from '../../GetHelpPage';
import WidgetWrapper from '../../../components/WidgetWrapper';
import FERCRiskEquationLong from '../VulnerabilityAssessment/images/FERCRiskEquationLong.png';
import { Buffer } from 'buffer';
import {v4} from 'uuid';



const SiteSecurityAssessment = () => {
// 
  // const [rows, setRows] = React.useState();
  const imageBase64Data = `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`;
  const imageBase64FERCEquation = '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';
  const [criticalDamAssets, setCriticalDamAssets] = useState();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [assessmentData, setAssessmentData] = useState();
  const axiosPrivate = useAxiosPrivate();
  const {assessmentID} = useParams();
  const [refresh, setRefresh] = useState(false);
  const criticalAssetItems = [];
  const criticalAssetList = [];
  const [threatProfiles, setThreatProfiles] = useState();

  const tableHeaderBackgroundColor = "#B2B0B0";
  const assessmentToolResults = [new TableRow({ children: [ 
    new TableCell({ children: [new Paragraph({text: "Critical Asset ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
    new TableCell({ children: [new Paragraph({text: "Attacker on Foot ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
    new TableCell({ children: [new Paragraph({text: "Attacker in Vehicle ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
    new TableCell({ children: [new Paragraph({text: "Attacker in Boat ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
       ]
      })];
const correctiveActionsList = [new TableRow({ children: [ 
  new TableCell({ children: [new Paragraph({text: "Task # ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
  new TableCell({ children: [new Paragraph({text: "Task Name ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
  new TableCell({ children: [new Paragraph({text: "Task Description ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
  new TableCell({ children: [new Paragraph({text: "Due Date ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
     ]
    })];

  const relativeRiskScoreList = [new TableRow({ children: [ 
  new TableCell({ children: [new Paragraph({text: "Critical Asset ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
  new TableCell({ children: [new Paragraph({text: "Security ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
  new TableCell({ children: [new Paragraph({text: "Consequences ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
  new TableCell({ children: [new Paragraph({text: "Vulnerabilities ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
  new TableCell({ children: [new Paragraph({text: "Likelihoods ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
  new TableCell({ children: [new Paragraph({text: "Threats ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}), 
  new TableCell({ children: [new Paragraph({text: "Relative Risk ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
  new TableCell({ children: [new Paragraph({text: "Risk Management Decision ", heading: HeadingLevel.HEADING_3})], shading: {fill: tableHeaderBackgroundColor}}),
    ],
     shading: {
      fill: "FF0000",
    },
  })];

  const [lowestScore, setLowestScore] = useState();
  const [highestScore, setHighestScore] = useState();
  const scoreListTemp = [];
  const [footScore, setFootScore] = useState(0);
  const [vehicleScore, setVehicleScore]= useState(0);
  const [boatScore, setBoatScore] = useState(0);
  const [correctiveActions , setCorrectiveActions] = useState();
  const [damName, setDamName] = useState("");
  const [damManned, setDamManned] = useState("");
  const [powerhouseManned, setPowerhouseManned] = useState("");
  const [damSurveillanceCameras, setDamSurveillanceCameras] = useState("");
  const [powerhouseSurveillanceCameras, setPowerhouseSurveillanceCameras] = useState("");
  const [howCamerasViewed, setHowCamerasViewed] = useState("");
  const [walkingInspections, setWalkingInspections] = useState("");
  const [lockedFence, setLockedFence] = useState("");
  const [accessRestrictionsFoot, setAccessRestrictionsFoot] = useState();
  const [accessRestrictionsVehicle, setAccessRestrictionsVehicle] = useState();
  const [accessRestrictionBoat, setAccessRestrictionBoat] = useState();
  const [spillwayGatesUnauthorizeAccess, setSpillwayGatesUnauthorizeAccess] = useState();
  const [powerhouseDoorsWindowsLocked, setPowerhouseDoorsWindowsLocked] = useState();
  const [powerhouseAlarms, setPowerhouseAlarms] = useState();
  const [powerhouseMotionDetectors, setPowerhouseMotionDetectors] = useState();
  const [delaySystemsBypass, setDelaySystemsBypass] = useState();
  const [restrictedAccessWaterConveyance, setRestrictedAccessWaterConveyance] = useState();
  const [surveillanceWaterConveyance, setSurveillanceWaterConveyance] = useState();
  const [cpmeTamperResistant, setCpmeTamperResistant] = useState();
  const [phoneNumbersLEPosted, setPhoneNumbersLEPosted] = useState();
  const [redundantComms, setRedundantComms] = useState();
  const [operatorResponseTime, setOperatorResponseTime] = useState();
  const [operatorResponseDescription, setOperatorResponseDescription] = useState();
  const [quicklyNotifyLE, setQuicklyNotifyLE] = useState();
  const [etaLE, setEtaLE] = useState();
  const [threatAssessment, setThreatAssessment] = useState();
  const [vulernableFeatures, setVulernableFeatures] = useState();
  const [potentailImpacts, setPotentailImpacts] = useState();
  const [dateLastLEConsultation, setDateLastLEConsultation] = useState();
  const [securityImprovementLastYear, setSecurityImprovementLastYear] = useState();
  const [securityImprovementLongTerm, setSecurityImprovementLongTerm] = useState();
  const [hasSecurityPlan, setHasSecurityPlan] = useState();
  const [overallSecurityPlanQuality, setOverallSecurityPlanQuality] = useState();
  const [responseRecoveryPlan, setResponseRecoveryPlan] = useState();
  const [siteSpecificResponseLevels, setSiteSpecificResponseLevels] = useState();
  const [currentandInspectionLevels, setCurrentandInspectionLevels] = useState();
  const [threatMeasuresRelevance, setThreatMeasuresRelevance] = useState();
  const [securityPlanRevision, setSecurityPlanRevision] = useState();
  const [exerciseLastDate, setExerciseLastDate] = useState();
  const [hasVulnerabilityAssessment, setHasVulnerabilityAssessment] = useState();
  const [hasSecurityAssessment, setHasSecurityAssessment] = useState();
  const [planActionIntegration, setPlanActionIntegration] = useState();
  const [conflictingSecurityMeasures, setConflictingSecurityMeasures] = useState();
  const [hasHazmat, setHasHazmat] = useState();
  const [hazmatSecureAccess, setHazmatSecureAccess] = useState();
  const [cdprSecured, setCdprSecured] = useState();
  const [pastYearSecurityIncidents, setPastYearSecurityIncidents] = useState();
  const [specificSecurityConcerns, setSpecificSecurityConcerns] = useState();
  const [otherAssessments, setOtherAssessments] = useState();
  const [changesSinceLastInspection, setChangesSinceLastInspection] = useState();
  const [physicalSiteSecurityChanges, setPhysicalSiteSecurityChanges] = useState();
  const [proceduralChanges, setProceduralChanges] = useState();
  const [cybersecurityChanges, setCybersecurityChanges] = useState();
  const [overallRiskReduction, setOverallRiskReduction] = useState();
  const [damMannedComments, setDamMannedComments] = useState("");
  const [powerhouseMannedComments, setPowerhouseMannedComments] = useState("");
  const [damSurveillanceCamerasComments, setDamSurveillanceCamerasComments] = useState("");
  const [powerhouseSurveillanceCamerasComments, setPowerhouseSurveillanceCamerasComments] = useState("");
  const [howCamerasViewedComments, setHowCamerasViewedComments] = useState("");
  const [walkingInspectionsComments, setWalkingInspectionsComments] = useState("");
  const [lockedFenceComments, setLockedFenceComments] = useState();
  const [accessRestrictionsFootComments, setAccessRestrictionsFootComments] = useState();
  const [accessRestrictionsVehicleComments, setAccessRestrictionsVehicleComments] = useState();
  const [accessRestrictionBoatComments, setAccessRestrictionBoatComments] = useState();
  const [spillwayGatesUnauthorizeAccessComments, setSpillwayGatesUnauthorizeAccessComments] = useState();
  const [powerhouseDoorsWindowsLockedComments, setPowerhouseDoorsWindowsLockedComments] = useState();
  const [powerhouseAlarmsComments, setPowerhouseAlarmsComments] = useState();
  const [powerhouseMotionDetectorsComments, setPowerhouseMotionDetectorsComments] = useState();
  const [delaySystemsBypassComments, setDelaySystemsBypassComments] = useState();
  const [restrictedAccessWaterConveyanceComments, setRestrictedAccessWaterConveyanceComments] = useState();
  const [surveillanceWaterConveyanceComments, setSurveillanceWaterConveyanceComments] = useState();
  const [cpmeTamperResistantComments, setCpmeTamperResistantComments] = useState();
  const [phoneNumbersLEPostedComments, setPhoneNumbersLEPostedComments] = useState();
  const [redundantCommsComments, setRedundantCommsComments] = useState();
  const [operatorResponseTimeComments, setOperatorResponseTimeComments] = useState();
  const [operatorResponseDescriptionComments, setOperatorResponseDescriptionComments] = useState();
  const [quicklyNotifyLEComments, setQuicklyNotifyLEComments] = useState();
  const [etaLEComments, setEtaLEComments] = useState();
  const [threatAssessmentComments, setThreatAssessmentComments] = useState();
  const [vulernableFeaturesComments, setVulernableFeaturesComments] = useState();
  const [potentailImpactsComments, setPotentailImpactsComments] = useState();
  const [dateLastLEConsultationComments, setDateLastLEConsultationComments] = useState();
  const [securityImprovementLastYearComments, setSecurityImprovementLastYearComments] = useState();
  const [securityImprovementLongTermComments, setSecurityImprovementLongTermComments] = useState();
  const [hasSecurityPlanComments, setHasSecurityPlanComments] = useState();
  const [overallSecurityPlanQualityComments, setOverallSecurityPlanQualityComments] = useState();
  const [responseRecoveryPlanComments, setResponseRecoveryPlanComments] = useState();
  const [siteSpecificResponseLevelsComments, setSiteSpecificResponseLevelsComments] = useState();
  const [currentandInspectionLevelsComments, setCurrentandInspectionLevelsComments] = useState();
  const [threatMeasuresRelevanceComments, setThreatMeasuresRelevanceComments] = useState();
  const [securityPlanRevisionComments, setSecurityPlanRevisionComments] = useState();
  const [exerciseLastDateComments, setExerciseLastDateComments] = useState();
  const [hasVulnerabilityAssessmentComments, setHasVulnerabilityAssessmentComments] = useState();
  const [hasSecurityAssessmentComments, setHasSecurityAssessmentComments] = useState();
  const [planActionIntegrationComments, setPlanActionIntegrationComments] = useState();
  const [conflictingSecurityMeasuresComments, setConflictingSecurityMeasuresComments] = useState();
  const [hasHazmatComments, setHasHazmatComments] = useState();
  const [hazmatSecureAccessComments, setHasmatSecureAccessComments] = useState();
  const [cdprSecuredComments, setCdprSecuredComments] = useState();
  const [pastYearSecurityIncidentsComments, setPastYearSecurityIncidentsComments] = useState();
  const [specificSecurityConcernsComments, setSpecificSecurityConcernsComments] = useState();
  const [otherAssessmentsComments, setOtherAssessmentsComments] = useState();
  const [changesSinceLastInspectionComments, setChangesSinceLastInspectionComments] = useState();
  const [physicalSiteSecurityChangesComments, setPhysicalSiteSecurityChangesComments] = useState();
  const [proceduralChangesComments, setProceduralChangesComments] = useState();
  const [cybersecurityChangesComments, setCybersecurityChangesComments] = useState();
  const [overallRiskReductionComments, setOverallRiskReductionComments] = useState();
  const [damMannedCommentsHoursDay, setDamMannedCommentsHoursDay] = useState("");
  const [damMannedCommentsDaysWeek, setDamMannedCommentsDaysWeek] = useState("");
  const [powerhouseMannedCommentsDaysWeek, setPowerhouseMannedCommentsDaysWeek] = useState("");
  const [powerhouseMannedCommentsHoursDay, setPowerhouseMannedCommentsHoursDay] = useState("");

  const [damData, setDamData] = useState();


//****************BEGIN ZONE SCORES VARIABLES*************************/
  const [allZoneData, setAllZoneData] = useState();

 const zoneData = [];
 const zoneDataForAppendix = [];

  const allTechniques = [
    "T0800",
"T0830",
"T0878",
"T0802",
"T0895",
"T0803",
"T0804",
"T0805",
"T0806",
"T0892",
"T0858",
"T0807",
"T0885",
"T0884",
"T0879",
"T0809",
"T0811",
"T0893",
"T0812",
"T0813",
"T0814",
"T0815",
"T0868",
"T0816",
"T0817",
"T0871",
"T0819",
"T0820",
"T0890",
"T0866",
"T0822",
"T0823",
"T0891",
"T0874",
"T0877",
"T0872",
"T0883",
"T0867",
"T0826",
"T0827",
"T0828",
"T0837",
"T0880",
"T0829",
"T0835",
"T0831",
"T0832",
"T0849",
"T0838",
"T0821",
"T0836",
"T0889",
"T0839",
"T0801",
"T0834",
"T0840",
"T0842",
"T0861",
"T0843",
"T0845",
"T0873",
"T0886",
"T0846",
"T0888",
"T0847",
"T0848",
"T0851",
"T0852",
"T0853",
"T0881",
"T0865",
"T0856",
"T0869",
"T0862",
"T0894",
"T0857",
"T0882",
"T0864",
"T0855",
"T0863",
"T0859",
"T0860",
"T0887"
  ];

  const allTechniquesMaxScore = [
    44, 
56, 
24, 
24, 
12, 
28, 
28, 
28, 
28, 
20, 
40, 
20, 
20, 
20, 
24, 
28, 
36, 
32, 
16, 
24, 
16, 
24, 
36, 
48, 
32, 
20, 
32, 
20, 
20, 
40, 
40, 
20, 
12, 
12, 
8, 
20, 
12, 
24, 
12, 
24, 
8, 
8, 
12, 
16, 
8, 
16, 
16, 
32, 
44, 
28, 
32, 
32, 
64, 
12, 
6, 
8, 
32, 
40, 
56, 
40, 
20, 
60, 
16, 
20, 
28, 
36, 
12, 
12, 
32, 
36, 
32, 
32, 
16, 
24, 
16, 
68, 
16, 
28, 
36, 
44, 
48, 
28, 
12, 
  ]

  const techniquesPerAsset2 = 
    {
      applicationServer: [
        "T0807",
        "T0809",
        "T0812",
        "T0816",
        "T0819",
        "T0820",
        "T0822",
        "T0823",
        "T0830",
        "T0834",
        "T0840",
        "T0842",
        "T0846",
        "T0847",
        "T0849",
        "T0851",
        "T0853",
        "T0859",
        "T0862",
        "T0866",
        "T0867",
        "T0869",
        "T0872",
        "T0874",
        "T0881",
        "T0883",
        "T0884",
        "T0885",
        "T0886",
        "T0888",
        "T0890",
        "T0892",
        "T0893",
        "T0894",
        "T0895",
      ],
      dataGateway: [
        "T0800",
        "T0830",
        "T0878",
        "T0804",
        "T0805",
        "T0892",
        "T0807",
        "T0885",
        "T0884",
        "T0809",
        "T0812",
        "T0814",
        "T0816",
        "T0871",
        "T0820",
        "T0890",
        "T0866",
        "T0822",
        "T0823",
        "T0874",
        "T0872",
        "T0849",
        "T0838",
        "T0801",
        "T0834",
        "T0840",
        "T0842",
        "T0861",
        "T0886",
        "T0846",
        "T0888",
        "T0847",
        "T0848",
        "T0851",
        "T0853",
        "T0881",
        "T0856",
        "T0869",
        "T0862",
        "T0857",
        "T0859"
      ],

      controlServer: [
        "T0801",
        "T0802",
        "T0803",
        "T0804",
        "T0805",
        "T0806",
        "T0807",
        "T0809",
        "T0811",
        "T0812",
        "T0814",
        "T0816",
        "T0820",
        "T0823",
        "T0830",
        "T0834",
        "T0840",
        "T0842",
        "T0846",
        "T0847",
        "T0848",
        "T0849",
        "T0851",
        "T0853",
        "T0855",
        "T0856",
        "T0859",
        "T0861",
        "T0862",
        "T0866",
        "T0867",
        "T0869",
        "T0872",
        "T0874",
        "T0878",
        "T0881",
        "T0884",
        "T0885",
        "T0886",
        "T0888",
        "T0890",
        "T0892",
        "T0893",
        "T0894",
        "T0895"
      ],
      dataHistorian: [
        "T0830",
        "T0878",
        "T0802",
        "T0895",
        "T0892",
        "T0807",
        "T0885",
        "T0884",
        "T0809",
        "T0811",
        "T0893",
        "T0812",
        "T0814",
        "T0816",
        "T0820",
        "T0890",
        "T0866",
        "T0822",
        "T0823",
        "T0874",
        "T0872",
        "T0849",
        "T0801",
        "T0834",
        "T0840",
        "T0842",
        "T0861",
        "T0886",
        "T0846",
        "T0888",
        "T0847",
        "T0848",
        "T0851",
        "T0853",
        "T0881",
        "T0869",
        "T0862",
        "T0894",
        "T0859"
      ],

      fieldio: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0830", 
        "T0834", 
        "T0847", 
        "T0851", 
        "T0859", 
        "T0860", 
        "T0862", 
        "T0867", 
        "T0871", 
        "T0884", 
        "T0885", 
        "T0887", 
        "T0888", 
        "T0891"
      ],

      hmi: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0807", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0823", 
        "T0830", 
        "T0834", 
        "T0838", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0849", 
        "T0851", 
        "T0852", 
        "T0853", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0863", 
        "T0866", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0886", 
        "T0888", 
        "T0890", 
        "T0892", 
        "T0893", 
        "T0894", 
        "T0895"
      ],

      ied: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0830", 
        "T0834", 
        "T0836", 
        "T0838", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0851", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0890", 
        "T0892"
      ],

      jumpHost: [
        "T0805", 
        "T0807", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0822", 
        "T0823", 
        "T0830", 
        "T0834", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0849", 
        "T0851", 
        "T0852", 
        "T0853", 
        "T0859", 
        "T0862", 
        "T0863", 
        "T0865", 
        "T0866", 
        "T0867", 
        "T0869", 
        "T0872", 
        "T0874", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0886", 
        "T0888", 
        "T0890", 
        "T0892", 
        "T0893", 
        "T0894", 
        "T0895"
      ],

      plc: [
        "T0800", 
        "T0801", 
        "T0802", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0821", 
        "T0830", 
        "T0834", 
        "T0835", 
        "T0836", 
        "T0838", 
        "T0839", 
        "T0840", 
        "T0842", 
        "T0843", 
        "T0845", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0851", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0858", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0868", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0877", 
        "T0878", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0889", 
        "T0890", 
        "T0892"
      ],

      rtu: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0830", 
        "T0834", 
        "T0836", 
        "T0838", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0892"
      ],

      routers: [
        "T0809", 
        "T0812", 
        "T0816", 
        "T0820", 
        "T0822", 
        "T0830", 
        "T0866", 
        "T0874", 
        "T0884", 
        "T0885", 
        "T0890", 
        "T0892"
      ],

      safetyController: [
        "T0800", 
        "T0801", 
        "T0803", 
        "T0804", 
        "T0805", 
        "T0806", 
        "T0809", 
        "T0812", 
        "T0814", 
        "T0816", 
        "T0820", 
        "T0821", 
        "T0830", 
        "T0834", 
        "T0835", 
        "T0838", 
        "T0839", 
        "T0840", 
        "T0842", 
        "T0843", 
        "T0845", 
        "T0846", 
        "T0847", 
        "T0848", 
        "T0851", 
        "T0855", 
        "T0856", 
        "T0857", 
        "T0858", 
        "T0859", 
        "T0861", 
        "T0862", 
        "T0866", 
        "T0868", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0874", 
        "T0877", 
        "T0878", 
        "T0881", 
        "T0884", 
        "T0885", 
        "T0888", 
        "T0889", 
        "T0890", 
        "T0892"
      ],

      vpnAsset: [
        "T0805", 
        "T0809", 
        "T0812", 
        "T0816", 
        "T0819", 
        "T0820", 
        "T0822", 
        "T0830", 
        "T0834", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0851", 
        "T0857", 
        "T0859", 
        "T0862", 
        "T0866", 
        "T0867", 
        "T0869", 
        "T0872", 
        "T0874", 
        "T0881", 
        "T0883", 
        "T0884", 
        "T0885", 
        "T0886", 
        "T0888", 
        "T0890", 
        "T0892"
      ],

      workstations: [
        "T0805", 
        "T0807", 
        "T0809", 
        "T0812", 
        "T0816", 
        "T0817", 
        "T0819", 
        "T0820", 
        "T0823", 
        "T0830", 
        "T0834", 
        "T0840", 
        "T0842", 
        "T0846", 
        "T0847", 
        "T0849", 
        "T0851", 
        "T0852", 
        "T0853", 
        "T0859", 
        "T0860", 
        "T0862", 
        "T0863", 
        "T0864", 
        "T0865", 
        "T0866", 
        "T0867", 
        "T0869", 
        "T0871", 
        "T0872", 
        "T0873", 
        "T0874", 
        "T0881", 
        "T0883", 
        "T0884", 
        "T0885", 
        "T0887", 
        "T0888", 
        "T0890", 
        "T0892", 
        "T0893", 
        "T0894", 
        "T0895"
      ]
    };

//****************END ZONE SCORES VARIABLES*************************/

 //**************START FERC CYBER CHECKLIST TABLE *****************/
 const form3List = [new TableRow({ children: [ 
  new TableCell({ children: [new Paragraph({text: " # ", heading: HeadingLevel.HEADING_3})]}),
  new TableCell({ children: [new Paragraph({text: " Field Observations: (Provide detailed supplemental information to the right)", heading: HeadingLevel.HEADING_3})]}), 
  new TableCell({ children: [new Paragraph({text: " Answer ", heading: HeadingLevel.HEADING_3})]}), 
  new TableCell({ children: [new Paragraph({text: " Comments", heading: HeadingLevel.HEADING_3})]}),
      ]
    })];

// Inventory 
  const [remoteAccess, setRemoteAccess] = useState("");
  const [remoteAccessConnected, setRemoteAccessConnected] = useState("");
  const [remoteAccessComments, setRemoteAccessComments] = useState("");

  // Overview.jsx
  const [scopingQuestions, setScopingQuestions] = useState(false);
  const [hasInventory, setHasInventory] = useState("");
  const [hasFERCDesignation, setHasFERCDesignation] = useState("");
  const [hasOtherFERCProjects, setHasOtherFERCProjects] = useState("");
  const [hasCybersecurityPlan, setHasCybersecurityPlan] = useState("");
  const [cybersecurityPlanName, setCybersecurityPlanName] = useState('');
  const [nERCCIPApplies, setNERCCIPApplies] = useState("");
  const [nERCCIPFindingsAddressed, setNERCCIPFindingsAddressed] = useState("");
  const [hasBusinessCyberAssets , setHasBusinessCyberAssets] = useState("");
  const [missionEssentialAssetsIdentified , setMissionEssentialAssetsIdentified] = useState("");
  const [userTraining, setUserTraining] = useState("");

  // Governance.jsx
  const hasPolicy = false;
  const [hasAccessControlPolicy, setHasAccessControlPolicy] = useState(false);
  const [hasAssetManagementPolicy, setHasAssetManagementPolicy] = useState(false);
  const [hasConfigurationManagementPolicy, setHasConfigurationManagementPolicy] = useState(false);
  const [hasSupplyChainRiskManagementPolicy, setHasSupplyChainRiskManagementPolicy] = useState(false);
  const [hasRemovableMediaPolicy, setHasRemovableMediaPolicy] = useState(false);
  const [doesAnnualPolicyReview, setDoesAnnualPolicyReview] = useState("");
  const [hasCybersecurityTeam, setHasCybersecurityTeam] = useState("");
  const [hasCyberRolesResponsibilities, setHasCyberRolesResponsibilities] = useState("");
  const [hasInternalCommunicationPlan, setHasInternalCommunicationPlan] = useState("");
  const [doesExternalCommunicationPlan, setDoesExternalCommunicationPlan] = useState("");
  const [doesResourceAssessment, setDoesResourceAssessment] = useState("");
  const [doesIndependentResourceAssessment, setDoesIndependentResourceAssessment] = useState("");
  const [hasPolicyComments, setHasPolicyComments] = useState("");
  const [doesAnnualPolicyReviewComments, setDoesAnnualPolicyReviewComments] = useState("");
  const [hasCybersecurityTeamComments, setHasCybersecurityTeamComments] = useState("");
  const [hasCyberRolesResponsibilitiesComments, setHasCyberRolesResponsibilitiesComments] = useState("");
  const [hasInternalCommunicationPlanComments, setHasInternalCommunicationPlanComments] = useState("");
  const [doesExternalCommunicationPlanComments, setDoesExternalCommunicationPlanComments] = useState("");
  const [doesResourceAssessmentComments, setDoesResourceAssessmentComments] = useState("");
  const [doesIndependentResourceAssessmentComments, setDoesIndependentResourceAssessmentComments] = useState("");


  // AccessControl.jsx
  const [hasLogicalAccessControl, setHasLogicalAccessControl] = useState("");
  const [has3rdPartyRemoteAccess, setHas3rdPartyRemoteAccess] = useState("");
  const [has3rdPartyRemoteAccessDescription, setHas3rdPartyRemoteAccessDescription] = useState("");
  const [has3rdPartyRemoteAccessList, setHas3rdPartyRemoteAccessList] = useState("");
  const [doesRemoteConnectionWeeklyReview, setDoesRemoteConnectionWeeklyReview] = useState("");
  const [knowsUnauthorizedAccessAttempts, setKnowsUnauthorizedAccessAttempts] = useState("");
  const [hasLogicalAccessControlComments, setHasLogicalAccessControlComments] = useState("");
  const [has3rdPartyRemoteAccessComments, setHas3rdPartyRemoteAccessComments] = useState("");
  const [has3rdPartyRemoteAccessDescriptionComments, setHas3rdPartyRemoteAccessDescriptionComments] = useState("");
  const [has3rdPartyRemoteAccessListComments, setHas3rdPartyRemoteAccessListComments] = useState("");
  const [doesRemoteConnectionWeeklyReviewComments, setDoesRemoteConnectionWeeklyReviewComments] = useState("");
  const [knowsUnauthorizedAccessAttemptsComments, setKnowsUnauthorizedAccessAttemptsComments] = useState("");


  //AssetConfigurationManagement.jsx
  const [knowsAssetCriticality, setKnowsAssetCriticality] = useState("");
  const [knowsAssetCriticalityComments, setKnowsAssetCriticalityComments] = useState("");
  const [doesRemoveConfigs, setDoesRemoveConfigs] = useState("");
  const [doesRemoveConfigsComments, setDoesRemoveConfigsComments] = useState("");
  const [hasConfigurationManagement, setHasConfigurationManagement] = useState("");
  const [hasConfigurationManagementComments, setHasConfigurationManagementComments] = useState("");

  //IntrusionDetectionResponseQuestions.jsx
  const [hasIntrusionDetectionResponsePolicy, setHasIntrusionDetectionResponsePolicy] = useState("");
  const [doesNotifyLawEnforcement, setDoesNotifyLawEnforcement] = useState("");
  const [doesExerciseResponsePlans, setDoesExerciseResponsePlans] = useState("");
  const [includesExerciseWithLawEnforcement, setIncludesExerciseWithLawEnforcement] = useState("");
  const [doesPostEventAnalysis, setDoesPostEventAnalysis] = useState("");
  const [includesAnalysisWithLawEnforcement, setIncludesAnalysisWithLawEnforcement] = useState("");
  const [incorporatesIDRLessonedLearned, setIncorporatesIDRLessonedLearned] = useState("");
  const [hasDedicatedSecMonTeam, setHasDedicatedSecMonTeam] = useState("");
  const [doesSecurityLogReviewFrequency, setDoesSecurityLogReviewFrequency] = useState("");
  const [hasIDRControlsImplemented, setHasIDRControlsImplemented] = useState("");
  const [doesWirelessAccessPointMonitoring, setDoesWirelessAccessPointMonitoring] = useState("");
  const [hasIntrusionDetectionResponsePolicyComments, setHasIntrusionDetectionResponsePolicyComments] = useState("");
  const [doesNotifyLawEnforcementComments, setDoesNotifyLawEnforcementComments] = useState("");
  const [doesExerciseResponsePlansComments, setDoesExerciseResponsePlansComments] = useState("");
  const [includesExerciseWithLawEnforcementComments, setIncludesExerciseWithLawEnforcementComments] = useState("");
  const [doesPostEventAnalysisComments, setDoesPostEventAnalysisComments] = useState("");
  const [includesAnalysisWithLawEnforcementComments, setIncludesAnalysisWithLawEnforcementComments] = useState("");
  const [incorporatesIDRLessonedLearnedComments, setIncorporatesIDRLessonedLearnedComments] = useState("");
  const [hasIDRControlsImplementedComments, setHasIDRControlsImplementedComments] = useState("");
  const [hasDedicatedSecMonTeamComments, setHasDedicatedSecMonTeamComments] = useState("");
  const [doesSecurityLogReviewFrequencyComments, setDoesSecurityLogReviewFrequencyComments] = useState("");
  const [doesWirelessAccessPointMonitoringComments, setDoesWirelessAccessPointMonitoringComments] = useState("");
  const [doesLogging, setDoesLogging] = useState(false);
  const [doesMonitoring, setDoesMonitoring] = useState(false);
  const [doesDetection, setDoesDetection] = useState(false);
  const [doesAnomalyIsolation, setDoesAnomalyIsolation] = useState(false);

  //SecurityArchitectureQuestions.jsx
  const [hasSecureDesignPrinciples, setHasSecureDesignPrinciples] = useState("");
  const [doesApproveNetworkConnections, setDoesApproveNetworkConnections] = useState("");
  const [hasSCADAWireless, setHasSCADAWireless] = useState("");
  const [hasSegmentedITOTNetworks, setHasSegmentedITOTNetworks] = useState("");
  const [hasSegmentedCriticalAssets, setHasSegmentedCriticalAssets] = useState("");
  const [doesDataCommNetwork, setDoesDataCommNetwork] = useState("");
  const [hasSecureDesignPrinciplesComments, setHasSecureDesignPrinciplesComments] = useState("");
  const [doesApproveNetworkConnectionsComments, setDoesApproveNetworkConnectionsComments] = useState("");
  const [hasSCADAWirelessComments, setHasSCADAWirelessComments] = useState("");
  const [hasSegmentedITOTNetworksComments, setHasSegmentedITOTNetworksComments] = useState("");
  const [hasSegmentedCriticalAssetsComments, setHasSegmentedCriticalAssetsComments] = useState("");
  const [doesDataCommNetworkComments, setDoesDataCommNetworkComments] = useState("");
  const [hasWirelessAccessControl,	setHasWirelessAccessControl	] = useState("");
  const [hasWirelessAccessControlComments,	setHasWirelessAccessControlComments] = useState("");

  //RiskManagementQuestions.jsx
  const [hasRiskManagementStrategy, setHasRiskManagementStrategy] = useState("");
  const [doesPeriodicRiskAssessments, setDoesPeriodicRiskAssessments] = useState("");
  const [doesAssessWirelessUse, setDoesAssessWirelessUse] = useState("");
  const [hasOrgWideRiskParticipation, setHasOrgWideRiskParticipation] = useState("");
  const [includesSupplyChainRiskManagement, setIncludesSupplyChainRiskManagement] = useState("");
  const [addressesInsiderThreat, setAddressesInsiderThreat] = useState("");
  const [doesThreatAssessment, setDoesThreatAssessment] = useState("");
  const [doesIndependentThreatAssessment, setDoesIndependentThreatAssessment] = useState("");
  const [hasRiskManagementStrategyComments, setHasRiskManagementStrategyComments] = useState("");
  const [doesPeriodicRiskAssessmentsComments, setDoesPeriodicRiskAssessmentsComments] = useState("");
  const [doesAssessWirelessUseComments, setDoesAssessWirelessUseComments] = useState("");
  const [hasOrgWideRiskParticipationComments, setHasOrgWideRiskParticipationComments] = useState("");
  const [includesSupplyChainRiskManagementComments, setIncludesSupplyChainRiskManagementComments] = useState("");
  const [addressesInsiderThreatComments, setAddressesInsiderThreatComments] = useState("");
  const [doesThreatAssessmentComments, setDoesThreatAssessmentComments] = useState("");
  const [doesIndependentThreatAssessmentComments, setDoesIndependentThreatAssessmentComments] = useState("");
  const [hasSituationAwareness, setHasSituationAwareness] = useState("");
  const [hasInformationSharing, setHasInformationSharing] = useState("");
  const [hasSituationAwarenessComments, setHasSituationAwarenessComments] = useState("");
  const [hasInformationSharingComments, setHasInformationSharingComments] = useState("");

  //SystemRestorationRecoveryQuestions.jsx
  const [hasRestorationRecoveryPlan, setHasRestorationRecoveryPlan] = useState("");
  const [doesTestRestorationRecoveryPlan, setDoesTestRestorationRecoveryPlan] = useState("");
  const [hasBackupSite, setHasBackupSite] = useState("");
  const [hasRestorationRecoveryPlanComments, setHasRestorationRecoveryPlanComments] = useState("");
  const [doesTestRestorationRecoveryPlanComments, setDoesTestRestorationRecoveryPlanComments] = useState("");
  const [hasBackupSiteComments, setHasBackupSiteComments] = useState("");
  
  //CyberTrainingQuestions
  const [hasUserTrainingRequirement, setHasUserTrainingRequirement] = useState("");
  const [hasAnnualUserTraining, setHasAnnualUserTraining] = useState("");
  const [hasPrivilegedUserTraining, setHasPrivilegedUserTraining] = useState("");
  const [hasSecurityRoleSpecificTraining, setHasSecurityRoleSpecificTraining] = useState("");
  const [hasUserAgreement, setHasUserAgreement] = useState("");
  const [hasUserTrainingRequirementComments, setHasUserTrainingRequirementComments] = useState("");
  const [hasAnnualUserTrainingComments, setHasAnnualUserTrainingComments] = useState("");
  const [hasPrivilegedUserTrainingComments, setHasPrivilegedUserTrainingComments] = useState("");
  const [hasSecurityRoleSpecificTrainingComments, setHasSecurityRoleSpecificTrainingComments] = useState("");
  const [hasUserAgreementComments, setHasUserAgreementComments] = useState("");

  
  const [hasAssetManagementPolicyComments, setHasAssetManagementPolicyComments] = useState("");
  const [hasConfigurationManagementPolicyComments, setHasConfigurationManagementPolicyComments] = useState("");
  const [hasSupplyChainRiskManagementPolicyComments, setHasSupplyChainRiskManagementPolicyComments] = useState("");
  const [doesSecurityLogReview, setDoesSecurityLogReview] = useState("");
  const [doesSecurityLogReviewComments, setDoesSecurityLogReviewComments] = useState("");

  
  // *************** Questionnaire specific Variables***************//


  // Inventory
  const [allCyberAssetData, setAllCyberAssetData] = useState();

  // General
  const [generalMeasure, setGeneralMeasure] = useState("");
  const [generalMeasureComments, setGeneralMeasureComments] = useState("");

  // InfoSecurityCoordinationResponsibilities
  const [infoSecurityCoordinationResponsibilities, setInfoSecurityCoordinationResponsibilities] = useState("");
  const [infoSecurityCoordinationResponsibilitiesComments, setInfoSecurityCoordinationResponsibilitiesComments] = useState("");


  // System Lifecycle
  const [systemLifecycle, setSystemLifecycle] = useState("");
  const [systemLifecycleComments, setSystemLifecycleComments] = useState("");

  // System Restoration and Recovery
  const [systemRestorationRecovery, setSystemRestorationRecovery] = useState("");
  const [systemRestorationRecoveryComments, setSystemRestorationRecoveryComments] = useState("");

  // Intrusion Detection and Response
  const [intrustionDetectionResponse, setIntrustionDetectionResponse] = useState("");
  const [intrustionDetectionResponseComments, setIntrustionDetectionResponseComments] = useState("");

  // Training
  const [training, setTraining] = useState("");
  const [trainingComments, setTrainingComments] = useState("");

  // Access Control and Functional Segregation
  const [accessControlFunctionalSegregation, setAccessControlFunctionalSegregation] = useState("");
  const [accessControlFunctionalSegregationComments, setAccessControlFunctionalSegregationComments] = useState("");

  // Access Control
  const [accessControl, setAccessControl] = useState("");
  const [accessControlComments, setAccessControlComments] = useState("");


  //**************START FERC CYBER CHECKLIST TABLE VARIABLE CREATION*****************/

  const current = new Date();
  const todayDate = `${current.getMonth()+1}/${current.getDate()}/${current.getFullYear()}`;



// const actionsList = ['action 1', 'action 2', 'action 3', 'action 4', 'action 5', 'action 6' ];


  // Get assessmnet data Function.  This should pull data for the assessment for the current assessment. 
  const getAssessmentData = async () => {
    try {
      const response = await axiosPrivate.get(`/assessment/${assessmentID}`, {
        withCredentials: true
      });
      const data = await response.data;
      setAssessmentData(data);
      // console.log(data);

    //****************BEGIN FERC HYDRO CYBER CHECKLIST VARIABLE ASSIGNMENT*********************/
      //Overview.jsx
    setHasInventory(data?.hasInventory?.toString());
    setHasFERCDesignation(data?.hasFERCDesignation?.toString());
    setHasOtherFERCProjects(data?.hasFERCDesignation?.toString());
    setHasCybersecurityPlan(data?.hasCybersecurityPlan?.toString());
    setCybersecurityPlanName(data?.cybersecurityPlanName?.toString());
    setNERCCIPApplies(data?.nERCCIPApplies?.toString());
    setNERCCIPFindingsAddressed(data?.nERCCIPFindingsAddressed?.toString());
    setHasBusinessCyberAssets(data?.hasBusinessCyberAssets?.toString());
    setMissionEssentialAssetsIdentified(data?.missionEssentialAssetsIdentified?.toString());

    //Governance.jsx 
    setHasAccessControlPolicy(data?.hasAccessControlPolicy?.toString());
    setHasAssetManagementPolicy(data?.hasAssetManagementPolicy?.toString());
    setHasConfigurationManagementPolicy(data?.hasConfigurationManagementPolicy?.toString());
    setHasSupplyChainRiskManagementPolicy(data?.hasSupplyChainRiskManagementPolicy?.toString());
    setHasRemovableMediaPolicy(data?.hasRemovableMediaPolicy?.toString());
    setDoesAnnualPolicyReview(data?.doesAnnualPolicyReview?.toString());
    setHasCybersecurityTeam(data?.hasCybersecurityTeam?.toString());
    setHasCyberRolesResponsibilities(data?.hasCyberRolesResponsibilities?.toString());
    setHasInternalCommunicationPlan(data?.hasInternalCommunicationPlan?.toString());
    setDoesExternalCommunicationPlan(data?.doesExternalCommunicationPlan?.toString());
    setDoesResourceAssessment(data?.doesResourceAssessment?.toString());
    setDoesIndependentResourceAssessment(data?.doesIndependentResourceAssessment?.toString());
    setDoesAnnualPolicyReviewComments(data?.doesAnnualPolicyReviewComments?.toString());

    //AccessControl.jsx
    setHasLogicalAccessControl(data?.hasLogicalAccessControl?.toString());
    setHas3rdPartyRemoteAccess(data?.has3rdPartyRemoteAccess?.toString());
    setHas3rdPartyRemoteAccessList(data?.has3rdPartyRemoteAccessList?.toString());
    setDoesRemoteConnectionWeeklyReview(data?.doesRemoteConnectionWeeklyReview?.toString());
    setKnowsUnauthorizedAccessAttempts(data?.knowsUnauthorizedAccessAttempts?.toString());
    setHasLogicalAccessControlComments(data?.hasLogicalAccessControlComments?.toString());
    setHas3rdPartyRemoteAccessComments(data?.has3rdPartyRemoteAccessComments?.toString());
    setHas3rdPartyRemoteAccessDescriptionComments(data?.has3rdPartyRemoteAccessDescriptionComments?.toString());
    setHas3rdPartyRemoteAccessListComments(data?.has3rdPartyRemoteAccessListComments?.toString());
    setDoesRemoteConnectionWeeklyReviewComments(data?.doesRemoteConnectionWeeklyReviewComments?.toString());
    setKnowsUnauthorizedAccessAttemptsComments(data?.knowsUnauthorizedAccessAttemptsComment?.toString());

    //AssetConfigurationManagement.jsx
    setKnowsAssetCriticality(data?.knowsAssetCriticality?.toString());
    setDoesRemoveConfigs(data?.doesRemoveConfigs?.toString());
    setHasConfigurationManagement(data?.hasConfigurationManagement?.toString());
    setKnowsAssetCriticalityComments(data?.knowsAssetCriticalityComments?.toString());
    setDoesRemoveConfigsComments(data?.doesRemoveConfigsComments?.toString());
    setHasConfigurationManagementComments(data?.hasConfigurationManagementComments?.toString());

    //IntrusionDetectionResponseQuestions.jsx
    setHasIntrusionDetectionResponsePolicy(data?.hasIntrusionDetectionResponsePolicy?.toString());
    setDoesNotifyLawEnforcement(data?.doesNotifyLawEnforcement?.toString());
    setDoesExerciseResponsePlans(data?.doesExerciseResponsePlans?.toString());
    setIncludesExerciseWithLawEnforcement(data?.includesExerciseWithLawEnforcement?.toString());
    setDoesPostEventAnalysis(data?.doesPostEventAnalysis?.toString());
    setIncludesAnalysisWithLawEnforcement(data?.includesAnalysisWithLawEnforcement?.toString());
    setIncorporatesIDRLessonedLearned(data?.incorporatesIDRLessonedLearned?.toString());
    setHasIDRControlsImplemented(data?.hasIDRControlsImplemented?.toString());
    setHasDedicatedSecMonTeam(data?.hasDedicatedSecMonTeam?.toString());
    setDoesSecurityLogReviewFrequency(data?.doesSecurityLogReviewFrequency?.toString());
    setDoesWirelessAccessPointMonitoring(data?.doesWirelessAccessPointMonitoring?.toString());
    setHasIntrusionDetectionResponsePolicyComments(data?.hasIntrusionDetectionResponsePolicyComments?.toString());
    setDoesNotifyLawEnforcementComments(data?.doesNotifyLawEnforcementComments?.toString());
    setDoesExerciseResponsePlansComments(data?.doesExerciseResponsePlansComments?.toString());
    setIncludesExerciseWithLawEnforcementComments(data?.includesExerciseWithLawEnforcementComments?.toString());
    setDoesPostEventAnalysisComments(data?.doesPostEventAnalysisComments?.toString());
    setIncludesAnalysisWithLawEnforcementComments(data?.includesAnalysisWithLawEnforcementComments?.toString());
    setIncorporatesIDRLessonedLearnedComments(data?.incorporatesIDRLessonedLearnedComments?.toString());
    setHasIDRControlsImplementedComments(data?.hasIDRControlsImplementedComments?.toString());
    setHasDedicatedSecMonTeamComments(data?.hasDedicatedSecMonTeamComments?.toString());
    setDoesSecurityLogReviewFrequencyComments(data?.doesSecurityLogReviewFrequencyComments?.toString());
    setDoesWirelessAccessPointMonitoringComments(data?.doesWirelessAccessPointMonitoringComments?.toString());
    setDoesLogging(data?.doesLogging?.toString());
    setDoesMonitoring(data?.doesMonitoring?.toString());
    setDoesDetection(data?.doesDetection?.toString());
    setDoesAnomalyIsolation(data?.doesAnomalyIsolation?.toString());

    //SecurityArchitectureQuestions.jsx
    setHasSecureDesignPrinciples(data?.hasSecureDesignPrinciples?.toString());
    setDoesApproveNetworkConnections(data?.doesApproveNetworkConnections?.toString());
    setHasSCADAWireless(data?.hasSCADAWireless?.toString());
    setHasSegmentedITOTNetworks(data?.hasSegmentedITOTNetworks?.toString());
    setHasSegmentedCriticalAssets(data?.hasSegmentedCriticalAssets?.toString());
    setDoesDataCommNetwork(data?.doesDataCommNetwork?.toString());
    setHasSecureDesignPrinciplesComments(data?.hasSecureDesignPrinciplesComments?.toString());
    setDoesApproveNetworkConnectionsComments(data?.doesApproveNetworkConnectionsComments?.toString());
    setHasSCADAWirelessComments(data?.hasSCADAWirelessComments?.toString());
    setHasSegmentedITOTNetworksComments(data?.hasSegmentedITOTNetworksComments?.toString());
    setHasSegmentedCriticalAssetsComments(data?.hasSegmentedCriticalAssetsComments?.toString());
    setDoesDataCommNetworkComments(data?.doesDataCommNetworkComments?.toString());
    setHasWirelessAccessControl(data?.hasWirelessAccessControl?.toString());
    setHasWirelessAccessControlComments(data?.hasWirelessAccessControlComments?.toString());

    //RiskManagementQuestions.jsx
    setHasRiskManagementStrategy(data?.hasRiskManagementStrategy?.toString());
    setDoesPeriodicRiskAssessments(data?.doesPeriodicRiskAssessments?.toString());
    setDoesAssessWirelessUse(data?.doesAssessWirelessUse?.toString());
    setHasOrgWideRiskParticipation(data?.hasOrgWideRiskParticipation?.toString());
    setIncludesSupplyChainRiskManagement(data?.includesSupplyChainRiskManagement?.toString());
    setAddressesInsiderThreat(data?.addressesInsiderThreat?.toString());
    setDoesThreatAssessment(data?.doesThreatAssessment?.toString());
    setDoesIndependentThreatAssessment(data?.doesIndependentThreatAssessment?.toString());
    setHasSituationAwareness(data?.hasSituationAwareness?.toString());
    setHasInformationSharing(data?.hasInformationSharing?.toString());
    setHasRiskManagementStrategyComments(data?.hasRiskManagementStrategyComments?.toString());
    setDoesPeriodicRiskAssessmentsComments(data?.doesPeriodicRiskAssessmentsComments?.toString());
    setDoesAssessWirelessUseComments(data?.doesAssessWirelessUseComments?.toString());
    setHasOrgWideRiskParticipationComments(data?.hasOrgWideRiskParticipationComments?.toString());
    setIncludesSupplyChainRiskManagementComments(data?.includesSupplyChainRiskManagementComments?.toString());
    setAddressesInsiderThreatComments(data?.addressesInsiderThreatComments?.toString());
    setDoesThreatAssessmentComments(data?.doesThreatAssessmentComments?.toString());
    setDoesIndependentThreatAssessmentComments(data?.doesIndependentThreatAssessmentComments?.toString());
    setHasSituationAwarenessComments(data?.hasSituationAwarenessComments?.toString());
    setHasInformationSharingComments(data?.hasInformationSharingComments?.toString());

    //SystemRestorationRecoveryQuestions.jsx
    setHasRestorationRecoveryPlan(data?.hasRestorationRecoveryPlan?.toString());
    setDoesTestRestorationRecoveryPlan(data?.doesTestRestorationRecoveryPlan?.toString());
    setHasBackupSite(data?.hasBackupSite?.toString());
    setHasRestorationRecoveryPlanComments(data?.hasRestorationRecoveryPlanComments?.toString());
    setDoesTestRestorationRecoveryPlanComments(data?.doesTestRestorationRecoveryPlanComments?.toString());
    setHasBackupSiteComments(data?.hasBackupSiteComments?.toString());
    
    //CyberTrainingQuestions
    setHasUserTrainingRequirementComments(data?.hasUserTrainingRequirementComments?.toString());
    setHasAnnualUserTrainingComments(data?.hasAnnualUserTrainingComments?.toString());
    setHasPrivilegedUserTrainingComments(data?.hasPrivilegedUserTrainingComments?.toString());
    setHasSecurityRoleSpecificTrainingComments(data?.hasSecurityRoleSpecificTrainingComments?.toString());
    setHasUserAgreementComments(data?.hasUserAgreementComments?.toString());
    setHasUserTrainingRequirement(data?.hasUserTrainingRequirement?.toString());
    setHasAnnualUserTraining(data?.hasAnnualUserTraining?.toString());
    setHasPrivilegedUserTraining(data?.hasPrivilegedUserTraining?.toString());
    setHasSecurityRoleSpecificTraining(data?.hasSecurityRoleSpecificTraining?.toString());
    setHasUserAgreement(data?.hasUserAgreement?.toString());
    
    //****************END FERC HYDRO CYBER CHECKLIST VARIABLE ASSIGNMENT*********************/

      try {
      const response = await axiosPrivate.get(`/dams/${data.damID}`, {
        withCredentials: true
      });
      const dataDam = await response.data;
      // console.log(dataDam);
      setDamData(dataDam);
    } catch (err) {
      console.log(err);
    }
      setDamName(data?.damName?.toString());
      setDamManned(data?.damManned?.toString());
      setPowerhouseManned(data?.powerhouseManned?.toString());
      setDamSurveillanceCameras(data?.damSurveillanceCameras?.toString());
      setPowerhouseSurveillanceCameras(data?.powerhouseSurveillanceCameras?.toString());
      setHowCamerasViewed(data?.howCamerasViewed?.toString());
      setWalkingInspections(data?.walkingInspections?.toString());
      setLockedFence(data?.lockedFence?.toString());
      setAccessRestrictionsFoot(data?.accessRestrictionsFoot?.toString());
      setAccessRestrictionsVehicle(data?.accessRestrictionsVehicle?.toString());
      setAccessRestrictionBoat(data?.accessRestrictionBoat?.toString());
      setSpillwayGatesUnauthorizeAccess(data?.spillwayGatesUnauthorizeAccess?.toString());
      setPowerhouseDoorsWindowsLocked(data?.powerhouseDoorsWindowsLocked?.toString());
      setPowerhouseAlarms(data?.powerhouseAlarms?.toString());
      setPowerhouseMotionDetectors(data?.powerhouseMotionDetectors?.toString());
      setDelaySystemsBypass(data?.delaySystemsBypass?.toString());
      setRestrictedAccessWaterConveyance(data?.restrictedAccessWaterConveyance?.toString());
      setSurveillanceWaterConveyance(data?.surveillanceWaterConveyance?.toString());
      setCpmeTamperResistant(data?.cpmeTamperResistant?.toString());
      setPhoneNumbersLEPosted(data?.phoneNumbersLEPosted?.toString());
      setRedundantComms(data?.redundantComms?.toString());
      setOperatorResponseTime(data?.operatorResponseTime?.toString());
      setOperatorResponseDescription(data?.operatorResponseDescription?.toString());
      setQuicklyNotifyLE(data?.quicklyNotifyLE?.toString());
      setEtaLE(data?.etaLE?.toString());
      setThreatAssessment(data?.threatAssessment?.toString());
      setVulernableFeatures(data?.vulernableFeatures?.toString());
      setPotentailImpacts(data?.potentailImpacts?.toString());
      setDateLastLEConsultation(data?.dateLastLEConsultation?.toString());
      setSecurityImprovementLastYear(data?.securityImprovementLastYear?.toString());
      setSecurityImprovementLongTerm(data?.securityImprovementLongTerm?.toString());
      setHasSecurityPlan(data?.hasSecurityPlan?.toString());
      setOverallSecurityPlanQuality(data?.overallSecurityPlanQuality?.toString());
      setResponseRecoveryPlan(data?.responseRecoveryPlan?.toString());
      setSiteSpecificResponseLevels(data?.siteSpecificResponseLevels?.toString());
      setCurrentandInspectionLevels(data?.currentandInspectionLevels?.toString());
      setThreatMeasuresRelevance(data?.threatMeasuresRelevance?.toString());
      setSecurityPlanRevision(data?.securityPlanRevision?.toString());
      setExerciseLastDate(data?.exerciseLastDate?.toString());
      setHasVulnerabilityAssessment(data?.hasVulnerabilityAssessment?.toString());
      setHasSecurityAssessment(data?.hasSecurityAssessment?.toString());
      setPlanActionIntegration(data?.planActionIntegration?.toString());
      setConflictingSecurityMeasures(data?.conflictingSecurityMeasures?.toString());
      setHasHazmat(data?.hasHazmat?.toString());
      setHazmatSecureAccess(data?.hazmatSecureAccess?.toString());
      setCdprSecured(data?.cdprSecured?.toString());
      setPastYearSecurityIncidents(data?.pastYearSecurityIncidents?.toString());
      setSpecificSecurityConcerns(data?.specificSecurityConcerns?.toString());
      setOtherAssessments(data?.otherAssessments?.toString());
      setChangesSinceLastInspection(data?.changesSinceLastInspection?.toString());
      setPhysicalSiteSecurityChanges(data?.physicalSiteSecurityChanges?.toString());
      setProceduralChanges(data?.proceduralChanges?.toString());
      setCybersecurityChanges(data?.cybersecurityChanges?.toString());
      setOverallRiskReduction(data?.overallRiskReduction?.toString());
      setDamMannedComments(data?.damMannedComments?.toString());
      setDamMannedCommentsDaysWeek(data?.damMannedCommentsDaysWeek?.toString());
      setDamMannedCommentsHoursDay(data?.damMannedCommentsHoursDay?.toString());
      setPowerhouseMannedComments(data?.powerhouseMannedComments?.toString());
      setPowerhouseMannedCommentsDaysWeek(data?.powerhouseMannedCommentsDaysWeek?.toString());
      setPowerhouseMannedCommentsHoursDay(data?.powerhouseMannedCommentsHoursDay?.toString());
      setDamSurveillanceCamerasComments(data?.damSurveillanceCamerasComments?.toString());
      setPowerhouseSurveillanceCamerasComments(data?.powerhouseSurveillanceCamerasComments?.toString());
      setHowCamerasViewedComments(data?.howCamerasViewedComments?.toString());
      setWalkingInspectionsComments(data?.walkingInspectionsComments?.toString());
      setLockedFenceComments(data?.lockedFenceComments?.toString());
      setAccessRestrictionsFootComments(data?.accessRestrictionsFootComments?.toString());
      setAccessRestrictionsVehicleComments(data?.accessRestrictionsVehicleComments?.toString());
      setAccessRestrictionBoatComments(data?.accessRestrictionBoatComments?.toString());
      setSpillwayGatesUnauthorizeAccessComments(data?.spillwayGatesUnauthorizeAccessComments?.toString());
      setPowerhouseDoorsWindowsLockedComments(data?.powerhouseDoorsWindowsLockedComments?.toString());
      setPowerhouseAlarmsComments(data?.powerhouseAlarmsComments?.toString());
      setPowerhouseMotionDetectorsComments(data?.powerhouseMotionDetectorsComments?.toString());
      setDelaySystemsBypassComments(data?.delaySystemsBypassComments?.toString());
      setRestrictedAccessWaterConveyanceComments(data?.restrictedAccessWaterConveyanceComments?.toString());
      setSurveillanceWaterConveyanceComments(data?.surveillanceWaterConveyanceComments?.toString());
      setCpmeTamperResistantComments(data?.cpmeTamperResistantComments?.toString());
      setPhoneNumbersLEPostedComments(data?.phoneNumbersLEPostedComments?.toString());
      setRedundantCommsComments(data?.redundantCommsComments?.toString());
      setOperatorResponseTimeComments(data?.operatorResponseTimeComments?.toString());
      setOperatorResponseDescriptionComments(data?.operatorResponseDescriptionComments?.toString());
      setQuicklyNotifyLEComments(data?.quicklyNotifyLEComments?.toString());
      setEtaLEComments(data?.etaLEComments?.toString());
      setThreatAssessmentComments(data?.threatAssessmentComments?.toString());
      setVulernableFeaturesComments(data?.vulernableFeaturesComments?.toString());
      setPotentailImpactsComments(data?.potentailImpactsComments?.toString());
      setDateLastLEConsultationComments(data?.dateLastLEConsultationComments?.toString());
      setSecurityImprovementLastYearComments(data?.securityImprovementLastYearComments?.toString());
      setSecurityImprovementLongTermComments(data?.securityImprovementLongTermComments?.toString());
      setHasSecurityPlanComments(data?.hasSecurityPlanComments?.toString());
      setOverallSecurityPlanQualityComments(data?.overallSecurityPlanQualityComments?.toString());
      setResponseRecoveryPlanComments(data?.responseRecoveryPlanComments?.toString());
      setSiteSpecificResponseLevelsComments(data?.siteSpecificResponseLevelsComments?.toString());
      setCurrentandInspectionLevelsComments(data?.currentandInspectionLevelsComments?.toString());
      setThreatMeasuresRelevanceComments(data?.threatMeasuresRelevanceComments?.toString());
      setSecurityPlanRevisionComments(data?.securityPlanRevisionComments?.toString());
      setExerciseLastDateComments(data?.exerciseLastDateComments?.toString());
      setHasVulnerabilityAssessmentComments(data?.hasVulnerabilityAssessmentComments?.toString());
      setHasSecurityAssessmentComments(data?.hasSecurityAssessmentComments?.toString());
      setPlanActionIntegrationComments(data?.planActionIntegrationComments?.toString());
      setConflictingSecurityMeasuresComments(data?.conflictingSecurityMeasuresComments?.toString());
      setHasHazmatComments(data?.hasHazmatComments?.toString());
      setHasmatSecureAccessComments(data?.hasmatSecureAccessComments?.toString());
      setCdprSecuredComments(data?.cdprSecuredComments?.toString());
      setPastYearSecurityIncidentsComments(data?.pastYearSecurityIncidentsComments?.toString());
      setSpecificSecurityConcernsComments(data?.specificSecurityConcernsComments?.toString());
      setOtherAssessmentsComments(data?.otherAssessmentsComments?.toString());
      setChangesSinceLastInspectionComments(data?.changesSinceLastInspectionComments?.toString());
      setPhysicalSiteSecurityChangesComments(data?.physicalSiteSecurityChangesComments?.toString());
      setProceduralChangesComments(data?.proceduralChangesComments?.toString());
      setCybersecurityChangesComments(data?.cybersecurityChangesComments?.toString());
      setOverallRiskReductionComments(data?.overallRiskReductionComments?.toString());
  

      } catch (err) {
        alert("Login Expirsed.");
        console.error(err);
        navigate('/login', { state: { from: location }, replace: true });
      }

    if (assessmentData === null) {
      return;
    } 
  };

// Get Dame Data
const getDam = async () => {
  let damID = assessmentData?.damID;
  try {
    const response = await axiosPrivate.get(`/dams/:${damID}`, {
      withCredentials: true
    });
    const data = await response.data;
    // console.log(data);
    setDamData(data);
    } catch (err) {
      console.log(err);
    }
  };


  // **************************BEGIN HYDRO CYBER CHECKLIST ANSWER CONDITIONING*****************/

   //Cybersecurity Measures Calculation
  const getGeneral = () => {
    setGeneralMeasureComments(hasLogicalAccessControlComments + knowsAssetCriticalityComments + doesAnnualPolicyReviewComments + doesApproveNetworkConnectionsComments + doesAssessWirelessUseComments);
    //  setGeneralMeasureComments(knowsAssetCriticalityComments + doesAnnualPolicyReviewComments + doesApproveNetworkConnectionsComments);
    if (hasLogicalAccessControl === "true" && knowsAssetCriticality === "true" && doesAnnualPolicyReview === "true" && doesApproveNetworkConnections === "true" && doesAssessWirelessUse === "true") {
      setGeneralMeasure('Yes');
    }
    else if (hasLogicalAccessControl === "false" && knowsAssetCriticality === "false" && doesAnnualPolicyReview === "false" && doesApproveNetworkConnections === "false" && doesAssessWirelessUse === "false") {
      setGeneralMeasure('No');
    }
    else {
      setGeneralMeasure('No');
    }
  };

  const getInfoSecurityCoordinationResponsibilities = () => {
    setInfoSecurityCoordinationResponsibilitiesComments(hasCybersecurityTeamComments + hasCyberRolesResponsibilitiesComments + hasInternalCommunicationPlanComments + doesExternalCommunicationPlanComments + includesSupplyChainRiskManagementComments );
    if (hasCybersecurityTeam === "true" && hasCyberRolesResponsibilities === "true" && hasInternalCommunicationPlan === "true" && doesExternalCommunicationPlan === "true" && includesSupplyChainRiskManagement === "true") {
      setInfoSecurityCoordinationResponsibilities('Yes');
    }
    else if (hasCybersecurityTeam === "false" && hasCyberRolesResponsibilities === "false" && hasInternalCommunicationPlan === "false" && doesExternalCommunicationPlan === "false" && includesSupplyChainRiskManagement === "false") {
      setInfoSecurityCoordinationResponsibilities('No');
    }
    else {
      setInfoSecurityCoordinationResponsibilities('No');
    }
  };

  // NEED TO ADD MITIGATION QUESTION TO COMPLETE THIS. 
  const getSystemLifecycle = () => {
    setInfoSecurityCoordinationResponsibilitiesComments(doesRemoveConfigsComments + hasConfigurationManagementComments + hasSecureDesignPrinciplesComments);
    if (doesRemoveConfigs === "true" && hasConfigurationManagement === "true" && hasSecureDesignPrinciples === "true" ) {
      setSystemLifecycle('Yes');
    }
    else if (doesRemoveConfigs === "false" && hasConfigurationManagement === "false" && hasSecureDesignPrinciples === "false") {
      setSystemLifecycle('No');
    }
    else {
      setSystemLifecycle('No');
    }
  };

  const getSystemRestorationRecovery = () => {
    setSystemRestorationRecoveryComments(hasRestorationRecoveryPlanComments + doesTestRestorationRecoveryPlanComments + hasBackupSiteComments);
    if (hasRestorationRecoveryPlan === "true" && doesTestRestorationRecoveryPlan === "true") {
      setSystemRestorationRecovery('Yes');
    }
    else if (doesRemoveConfigs === "false" && hasConfigurationManagement === "false" && hasSecureDesignPrinciples === "false") {
      setSystemRestorationRecovery('No');
    }
    else {
      setSystemRestorationRecovery('No');
    }
  };

  // NEED TO ADD REPORTING QUESTION TO COMPLETE THIS. 
  const getIntrusionDetectionResponse = () => {
    setIntrustionDetectionResponseComments(hasIntrusionDetectionResponsePolicyComments + hasIDRControlsImplementedComments);
    if (hasIntrusionDetectionResponsePolicy === "true" && doesLogging === "true" && doesMonitoring && doesDetection && doesAnomalyIsolation) {
      setIntrustionDetectionResponse('Yes');
    }
    else if (hasIntrusionDetectionResponsePolicy === "false" && doesLogging === "false" && doesMonitoring === "false" && doesDetection === 'false' & doesAnomalyIsolation === 'false') {
      setIntrustionDetectionResponse('No');
    }
    else {
      setIntrustionDetectionResponse('No');
    }
  };

  //NEED TO ADJUST THIS FOR TRAINING.
  const getTraining = () => {
    setTrainingComments(hasUserTrainingRequirementComments + hasAnnualUserTrainingComments + hasSecurityRoleSpecificTrainingComments);
    if (hasUserTrainingRequirement === "true" && hasAnnualUserTraining === "true" && hasSecurityRoleSpecificTraining === "true") {
      setTraining('Yes');
    }
    else if (hasUserTrainingRequirement === "false" && hasAnnualUserTraining === "false" && hasSecurityRoleSpecificTraining === "false") {
      setTraining('No');
    }
    else {
      setTraining('No');
    }
  };
 
  //NEED TO ADJUST THIS FOR ACCESS CONTROL & FUNCTIONAL SEGREGATION.
  const getAccessControlFunctionalSegregation = () => {
    setAccessControlFunctionalSegregationComments(hasPolicyComments + hasLogicalAccessControlComments + hasSegmentedITOTNetworksComments + hasUserAgreementComments);
    if (hasAccessControlPolicy === "true" && hasLogicalAccessControl === "true" && hasSegmentedITOTNetworks === "true" && hasUserAgreement === "true") {
      setAccessControlFunctionalSegregation('Yes');
    }
    else if (hasAccessControlPolicy === "false" && hasLogicalAccessControl === "false" && hasSegmentedITOTNetworks === "false" && hasUserAgreement === 'false') {
      setAccessControlFunctionalSegregation('No');
    }
    else {
      setAccessControlFunctionalSegregation('No');
    }
  };

  const getAccessControl = () => {
    setAccessControlComments(hasLogicalAccessControlComments + doesAssessWirelessUseComments);
    if (hasLogicalAccessControl === "true" && doesAssessWirelessUse === "true") {
      setAccessControl('Yes');
    }
    else if (hasLogicalAccessControl === "false" && doesAssessWirelessUse === "false") {
      setAccessControl('No');
    }
    else {
      setAccessControl('No');
    }
  };

  // Get cyberAssets Function.  This should pull cyberAssets for the current assessment. 
const getCyberAssets = async () => {
  const response = await axiosPrivate.get(`/assets/cyberassets/${assessmentID}`, {
      withCredentials: true
  });
  const data = await response.data;
  // console.log(data);
  setAllCyberAssetData(data);

  for (let index=0; index<data.length; index++) {
    if (data[index].remoteAccessConnected==='yes') {
      setRemoteAccessConnected('Yes');
      setRemoteAccessComments('See inventory answers for details.');
      break;
    } else if (data[index].remoteAccessConnected) {
      setRemoteAccessConnected('No');
    }
  }
  
  for (let index=0; index<data.length; index++) {
    if (data[index].remoteAccess==='yes') {
      setRemoteAccess('Yes');
      setRemoteAccessComments('See inventory answers for details.');
      break;
    } else if (data[index].remoteAccess==='no') {
      setRemoteAccess('No');
    }
  }
  if (allCyberAssetData === null) {
      return;
  }
};


// **************************END HYDRO CYBER CHECKLIST ANSWER CONDITIONING*****************/

   const getId = () => {
    let id = v4();
    return (
      `dndnode_${id}`
    )
  }

     // Get Critical Assets Function.  This should pull cyberAssets for the current assessment. 
const getCriticalAssets = async () => {
  try {
    const response = await axiosPrivate.get(`/criticalassets/criticalassets/${assessmentID}`, {
        withCredentials: true
    });
    const data = await response.data;
    // console.log(data);
    setCriticalDamAssets(data);

    let footScore1 = 0;
    let vehicleScore1 = 0;
    let boatScore1 = 0;

    for (let index in data) {
        let tempCriticalAsset = data[index];
        let tempScoreFoot = tempCriticalAsset.externalAccess + tempCriticalAsset.physicalSecurity + tempCriticalAsset.detection + tempCriticalAsset.delay + tempCriticalAsset.response + tempCriticalAsset.responseTime + tempCriticalAsset.assessmentExternal + tempCriticalAsset.assessmentInternal + tempCriticalAsset.securityAssessment + tempCriticalAsset.securityPlan + tempCriticalAsset.cybersecurity + tempCriticalAsset.cpme + tempCriticalAsset.cdpr;
        footScore1 = footScore1 + tempScoreFoot;
        

        let tempScoreVehicle = tempCriticalAsset.externalAccessVehicle + tempCriticalAsset.physicalSecurityVehicle + tempCriticalAsset.detectionVehicle + tempCriticalAsset.delayVehicle + tempCriticalAsset.responseVehicle + tempCriticalAsset.responseTimeVehicle + tempCriticalAsset.assessmentExternalVehicle + tempCriticalAsset.assessmentInternalVehicle + tempCriticalAsset.securityAssessmentVehicle + tempCriticalAsset.securityPlanVehicle + tempCriticalAsset.cybersecurityVehicle + tempCriticalAsset.cpme + tempCriticalAsset.cdpr;
        vehicleScore1 = vehicleScore1 + tempScoreVehicle;
        
        let tempScoreBoat = tempCriticalAsset.externalAccessBoat + tempCriticalAsset.physicalSecurityBoat + tempCriticalAsset.detectionBoat + tempCriticalAsset.delayBoat + tempCriticalAsset.responseBoat + tempCriticalAsset.responseTimeBoat + tempCriticalAsset.assessmentExternalBoat + tempCriticalAsset.assessmentInternalBoat + tempCriticalAsset.securityAssessmentBoat + tempCriticalAsset.securityPlanBoat + tempCriticalAsset.cybersecurityBoat + tempCriticalAsset.cpme + tempCriticalAsset.cdpr;
        boatScore1 = boatScore1 + tempScoreBoat;
    }
    setFootScore((footScore1 / (data.length+2)).toFixed(0));
    setVehicleScore((vehicleScore1 / (data.length+2)).toFixed(0));
    setBoatScore((boatScore1 / (data.length+2)).toFixed(0));
  } catch (err) {
    // alert("Login Expired.");
    console.error(err);
    // navigate('/login', { state: { from: location }, replace: true });
  }
};

// Get Threat Profile for each Critical Asset.
 const getThreatProfiles = async () => {

  try {
      const response = await axiosPrivate.get(`/threatprofiles/${assessmentID}`, {
          withCredentials: true
      });
      const data = await response.data;
      setThreatProfiles(data);
      
    } catch (err) {
      // alert("Login Expired.");
      console.error(err);
      // navigate('/login', { state: { from: location }, replace: true });
    }
    // console.log('T,V,L,C Scores for all Critical Assets');
    // console.log(TVLC[allCriticalAssetData[0].assetName]);
};

 // Get zones for this assessment. 
    const getZones = async () => {
      try {
        const response = await axiosPrivate.get(`/zones/${assessmentID}`, {
            withCredentials: true
        });
        const data = await response.data;
        setAllZoneData(data);
        // console.log(data);
      } catch (err) {
        // alert("Login Expired.");
        console.error(err);
        // navigate('/login', { state: { from: location }, replace: true });
      }
    };


 // Get Corrective Actions Function.  This should pull cyberAssets for the current assessment. 
 const getCorrectiveActions = async () => {
  try {
    const response = await axiosPrivate.get(`/correctiveactionplan/${assessmentID}`, {
      withCredentials: true
    });
    const data = await response.data;
    // console.log(data);
    setCorrectiveActions(data || "");
  } catch (err) {
    // alert("Login Expired.");
    console.error(err);
    // navigate('/login', { state: { from: location }, replace: true });
  }
};


const getSecurityAssessmentScoresFoot = (index) => {
  const securityAssessmentScoreFoot = index.externalAccess + index.physicalSecurity + index.detection + index.delay + index.response + index.responseTime + index.assessmentExternal + index.assessmentInternal + index.securityAssessment + index.securityPlan + index.cybersecurity; // + index.cpme + index.cdpr;
  return (
      securityAssessmentScoreFoot
  )
};

const getSecurityAssessmentScoresVehicle = (index) => {
  try{
      const securityAssessmentScoreVehicle = index.externalAccessVehicle + index.physicalSecurityVehicle + index.detectionVehicle + index.delayVehicle + index.responseVehicle + index.responseTimeVehicle + index.assessmentExternalVehicle + index.assessmentInternalVehicle + index.securityAssessmentVehicle + index.securityPlanVehicle + index.cybersecurityVehicle; // + index.cpme + index.cdpr;
      return (
          // index.physicalSecurityVehicle
          securityAssessmentScoreVehicle
      )       
  } catch (err) {
      console.log(err);
  }       
};

const getSecurityAssessmentScoresBoat = (index) => {
  const securityAssessmentScoreBoat = index.externalAccessBoat + index.physicalSecurityBoat + index.detectionBoat + index.delayBoat + index.responseBoat + index.responseTimeBoat + index.assessmentExternalBoat + index.assessmentInternalBoat + index.securityAssessmentBoat + index.securityPlanBoat + index.cybersecurityBoat; // + index.cpme + index.cdpr;

  return (
      securityAssessmentScoreBoat
  )
};


const CriticalAssetsListForReport = () => {
  if (criticalDamAssets?.length>=1) {
    // console.log('Length of Critical Dam Assets is: ' + criticalDamAssets.length);
    for (let index in criticalDamAssets) {
      // console.log(criticalDamAssets[index]);
      criticalAssetList.push(new Paragraph({text: criticalDamAssets[index].assetName, bullet: {level: 0}}))
      criticalAssetItems.push(new TableRow({ 
        children: [ 
          new TableCell({ 
            children: [
              new Paragraph({text: criticalDamAssets[index].assetName,  
                style: "normalPara2", 
                bullet: {level: 0}})], 
                borders: {
                  top: {
                      style: BorderStyle.NONE,
                      size: 3,
                      // color: "FF0000",
                  },
                  bottom: {
                      style: BorderStyle.NONE,
                      size: 3,
                      // color: "0000FF",
                  },
                  left: {
                      style: BorderStyle.NONE,
                      size: 3,
                      // color: "00FF00",
                  },
                  right: {
                      style: BorderStyle.NONE,
                      size: 3,
                      // color: "#ff8000",
                  },
    }, 
  }) 
]
    }),
  )
    let footScoreTemp = getSecurityAssessmentScoresFoot(criticalDamAssets[index]);
    let vehicleScoreTemp = getSecurityAssessmentScoresVehicle(criticalDamAssets[index]);
    let boatScoreTemp = getSecurityAssessmentScoresBoat(criticalDamAssets[index]);
    // scoreListTemp.push(getSecurityAssessmentScoresFoot(criticalDamAssets[index]), getSecurityAssessmentScoresVehicle(criticalDamAssets[index]), getSecurityAssessmentScoresBoat(criticalDamAssets[index]));
    scoreListTemp.push(footScoreTemp, vehicleScoreTemp, boatScoreTemp);
    assessmentToolResults.push(new TableRow({ children: [ 
      new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.assetName, style: "wellSpaced"})]}), 
      new TableCell({ children: [new Paragraph({text: footScoreTemp.toString(), style: "wellSpaced", alignment: AlignmentType.CENTER})] }), 
      new TableCell({ children: [new Paragraph({text: vehicleScoreTemp.toString(), style: "wellSpaced", alignment: AlignmentType.CENTER})]}),
      new TableCell({ children: [new Paragraph({text: boatScoreTemp.toString(), style: "wellSpaced", alignment: AlignmentType.CENTER})]}),
         ]
        })
      ) 
  } 
  } else {
    // console.log('Length of Critical Dam Assets is currently less than 1: ' + criticalDamAssets?.length);
   criticalAssetItems.push(new TableRow({ children: [ new TableCell({ children: [new Paragraph({text: "See Attachment",  style: "normalPara2", bullet: {level: 0}})], borders: {
    top: {
        style: BorderStyle.NONE,
        size: 3,
        // color: "FF0000",
    },
    bottom: {
        style: BorderStyle.NONE,
        size: 3,
        // color: "0000FF",
    },
    left: {
        style: BorderStyle.NONE,
        size: 3,
        // color: "00FF00",
    },
    right: {
        style: BorderStyle.NONE,
        size: 3,
        // color: "#ff8000",
    },
}, }) ]
}))
assessmentToolResults.push(new TableRow({ children: [ new TableCell({ children: [new Paragraph({text: "See Attachment",  style: "normalPara2", bullet: {level: 0}})], borders: {
  top: {
      style: BorderStyle.NONE,
      size: 3,
      // color: "FF0000",
  },
  bottom: {
      style: BorderStyle.NONE,
      size: 3,
      // color: "0000FF",
  },
  left: {
      style: BorderStyle.NONE,
      size: 3,
      // color: "00FF00",
  },
  right: {
      style: BorderStyle.NONE,
      size: 3,
      // color: "#ff8000",
  },
}, }) ]
}))
  }
  
};

const CorrectiveActionsforReport = () => {
  if (correctiveActions) {

  
  for (let index in correctiveActions) {
  correctiveActionsList.push(new TableRow({ children: [ 
    new TableCell({ children: [new Paragraph({text: correctiveActions[index]?.taskNumber, style: "wellSpaced"})]}), 
    new TableCell({ children: [new Paragraph({text: correctiveActions[index]?.taskName, style: "wellSpaced"})] }), 
    new TableCell({ children: [new Paragraph({text: correctiveActions[index]?.taskDescription, style: "wellSpaced"})]}),
    new TableCell({ children: [new Paragraph({text: correctiveActions[index]?.dueDate, style: "wellSpaced"})]}),
       ]
      })
    )
  }
} 
}

const ZoneDataForReport = () => {
  console.log(allZoneData);
  if (allZoneData===undefined) {
    return;
  } else if (allZoneData.length===0) {
    zoneData.push(
      new Paragraph({
        text: `No zones have been defined.`,
        heading: HeadingLevel.HEADING_4,
      }),
      new Paragraph({
        text: `Zones or Network Segements have not been defined for this assessment. To add an assessment of Mitre ATT&CK techniques to this assessment go the the "Cyber/SCADA ASSESSMENT" tab and add zones in teh "Define Zones" step. Then answer the questions in the "Cyber/SCADA Asset Assessment" step.`,
        style: "normalPara2",
      }),
    );
    return;
  } else {
  for (let zone in allZoneData) {
      let count = JSON.parse(allZoneData[zone].zoneData).assetTypes;
      let boundary = JSON.parse(allZoneData[zone].zoneData).boundaryProtection;
      let segmentation = JSON.parse(allZoneData[zone].zoneData).segmentationType;
      
      zoneData.push(
      new Paragraph({
        text: `${allZoneData[zone]?.zoneName}`,
        heading: HeadingLevel.HEADING_4,
      }),
      new Paragraph({
        text: `${allZoneData[zone]?.zoneDescription}`,
        style: "normalPara2",
      }),
    )
      zoneData.push(new Paragraph({
        text: `Boundary Protection: `,
        style: "normalPara2",
      }),);
      if (boundary.firewall===true) {
        zoneData.push(new Paragraph({
          text: `Firewall`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (boundary.dataDiode===true) {
        zoneData.push(new Paragraph({
          text: `DataDiode`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (boundary.router===true) {
        zoneData.push(new Paragraph({
          text: `Router`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (boundary.switch===true) {
        zoneData.push(new Paragraph({
          text: `Switch`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (boundary.other===true) {
        zoneData.push(new Paragraph({
            text: `DESCRIBE THE BOUNDARY TYPE`,
            bullet: {level: 0},
            style: "normalPara2"
          }))
      }
      zoneData.push(new Paragraph({
        text: `Segmentation Type: `,
        style: "normalPara2",
      }),);
      if (segmentation.vpn===true) {
        zoneData.push(new Paragraph({
          text: `Virtual Private Network`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (segmentation.physicalNetwork===true) {
        zoneData.push(new Paragraph({
          text: `Physically Separated Network`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (segmentation.sdn===true) {
        zoneData.push(new Paragraph({
          text: `Software Defined Network`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (segmentation.vlan===true) {
        zoneData.push(new Paragraph({
          text: `Virtual Local Area Network`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (segmentation.subnetting===true) {
        zoneData.push(new Paragraph({
          text: `Subnetting`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }
      if (segmentation.other===true) {
        zoneData.push(new Paragraph({
          text: `DESCRIBE THE SEGMENTATION TYPE`,
          bullet: {level: 0},
          style: "normalPara2"
        }))
      }


    let tempAssetRows = [new TableRow({
      children: [
        new TableCell({
          children: [
            new Paragraph({
              text: `Asset Type`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      new TableCell({
        children: [
          new Paragraph({
            text: "Quantity",
            heading: HeadingLevel.HEADING_3})], 
            shading: {fill: tableHeaderBackgroundColor},
        verticalAlign: VerticalAlign.CENTER,
      }),
        ],
    }),];

    let techniquesPerAssetRowHeader = [
      new TableCell({
        children: [
          new Paragraph({
            text: `Technique`,
            heading: HeadingLevel.HEADING_3})], 
            shading: {fill: tableHeaderBackgroundColor}
      }),
    ];

    let columnFilterList = ["technique"];


    if (count?.applicationServer===true) {
      columnFilterList.push("applicationServer");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Application Server`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.applicationServerQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Application Server`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.controlServer===true) {
      columnFilterList.push("controlServer");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Control Server`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.controlServerQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Control Server`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.dataGateway===true) {
      columnFilterList.push("dataGateway");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Data Gateway`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.dataGatewayQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Data Gateway`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.dataHistorian===true) {
      columnFilterList.push("dataHistorian");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Data Historian`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.dataHistorianQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Data Historian`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.fieldio===true) {
      columnFilterList.push("fieldio");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Field IO`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.fieldioQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Field IO`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.hmi===true) {
      columnFilterList.push("hmi");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Human Machine Interface`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.hmiQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Human Machine Interface`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.ied===true) {
      columnFilterList.push("ied");
      tempAssetRows.push(new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                text: `Intelligent Electronic Devices`,

              }),
            ],
          }),
        new TableCell({
          children: [
            new Paragraph({
              text: `${count?.iedQuantity}`,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
        }),
          ],
      }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Intelligent Electronic Devices`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.jumpHost===true) {
      columnFilterList.push("jumpHost");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Jump Host`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.jumpHostQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Jump Host`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.plc===true) {
      columnFilterList.push("plc");
      tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Programmable Logic Controller`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.plcQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Programmable Logic Controller`,
            heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.routers===true) {
      columnFilterList.push("routers");
        tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Routers`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.routersQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Routers`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.rtu===true) {
      columnFilterList.push("rtu");
        tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Remote Terminal Unit`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.rtuQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Remote Terminal Unit`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.safetyController===true) {
      columnFilterList.push("safetyController");
        tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Safety Controller`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.safetyControllerQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Safety Controller`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.vpnAsset===true) {
      columnFilterList.push("vpnAsset");
        tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Virtual Private Network`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.vpnQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Virtual Private Network`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    if (count?.workstations===true) {
      columnFilterList.push("workstations");
              tempAssetRows.push(new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Workstations`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `${count?.workstationsQuantity}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),
      )
      techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Workstations`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    }
    columnFilterList.push("score");
    techniquesPerAssetRowHeader.push(
        new TableCell({
          children: [
            new Paragraph({
              text: `Score`,
              heading: HeadingLevel.HEADING_3})], 
              shading: {fill: tableHeaderBackgroundColor}
        }),
      )
    // tempColumns.push(
    //       {
    //       field: "score",
    //       headerName: "Score",
    //       flex: 2,
    //     },
    //   )


    zoneData.push(new Table({
        rows: tempAssetRows,
        width: { size: 100, type: WidthType.PERCENTAGE },
        margins: {
          top: convertInchesToTwip(0.05),
          bottom: convertInchesToTwip(0.05),
          right: convertInchesToTwip(0.05),
          left: convertInchesToTwip(0.05),
          style: "wellSpaced"
      },
    }),)

      // console.log(tempColumns);
      
      let tempArray = [];
      if (count?.applicationServer===true && typeof(count?.applicationServerQuantity) === 'string') {tempArray.push(Number(count?.applicationServerQuantity))}
      if (count?.controlServer===true && typeof(count?.controlServerQuantity) === 'string') {tempArray.push(Number(count?.controlServerQuantity))}
      if (count?.dataGateway===true && typeof(count?.dataGatewayQuantity) === 'string') {tempArray.push(Number(count?.dataGatewayQuantity))}
      if (count?.dataHistorian===true && typeof(count?.dataHistorianQuantity) === 'string') {tempArray.push(Number(count?.dataHistorianQuantity))}
      if (count?.fieldio===true && typeof(count?.fieldioQuantity) === 'string') {tempArray.push(Number(count?.fieldioQuantity))}
      if (count?.hmi===true && typeof(count?.hmiQuantity) === 'string') {tempArray.push(Number(count?.hmiQuantity))}
      if (count?.ied===true && typeof(count?.iedQuantity) === 'string') {tempArray.push(Number(count?.iedQuantity))}
      if (count?.jumpHost===true && typeof(count?.jumpHostQuantity) === 'string') {tempArray.push(Number(count?.jumpHostQuantity))}
      if (count?.plc===true && typeof(count?.plcQuantity) === 'string') {tempArray.push(Number(count?.plcQuantity))}
      if (count?.routers===true && typeof(count?.routersQuantity) === 'string') {tempArray.push(Number(count?.routersQuantity))}
      if (count?.rtu===true && typeof(count?.rtuQuantity) === 'string') {tempArray.push(Number(count?.rtuQuantity))}
      if (count?.safetyController===true && typeof(count?.safetyControllerQuantity) === 'string') {tempArray.push(Number(count?.safetyControllerQuantity))}
      if (count?.vpnAsset===true && typeof(count?.vpnAssetQuantity) === 'string') {tempArray.push(Number(count?.vpnAssetQuantity))}
      if (count?.workstations===true && typeof(count?.workstationsQuantity) === 'string') {tempArray.push(Number(count?.workstationsQuantity))}
      // let tempArray = [ Number(count?.applicationServerQuantity), Number(count?.dataGatewayQuantity), Number(count?.dataHistorianQuantity), Number(count?.fieldioQuantity), Number(count?.hmiQuantity), Number(count?.iedQuantity), Number(count?.jumpHostQuantity), Number(count?.plcQuantity), Number(count?.routersQuantity), Number(count?.rtuQuantity), Number(count?.safetyControllerQuantity), Number(count?.vpnAssetQuantity), Number(count?.workstationsQuantity)];
      let totalCount = tempArray.reduce((acc, value) => {
          return typeof value === 'number' ? acc + value : acc;
        }, 0);

      let tempTotalZoneScore = 0;
      let tempZoneScore = 0;
      let tempList = [];
      for (let technique in allTechniques) {
        let tempScore = 0;
        // let id = getId();
        const getScore = (qnty) => {
          tempTotalZoneScore = tempTotalZoneScore + 1;
          tempZoneScore = tempZoneScore + Number((((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*qnty) / totalCount));
          console.log(allTechniques[technique]);
          console.log(tempScore, allZoneData[zone][allTechniques[technique]], allTechniquesMaxScore[technique], qnty, totalCount);
          tempScore = tempScore + Number((((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*qnty) / totalCount));
          console.log(tempScore);
          return (((allZoneData[zone][allTechniques[technique]] / allTechniquesMaxScore[technique])*qnty) / totalCount).toFixed(2)
        }

        tempList.push(
          {
            // _id: id,
            technique: allTechniques[technique],
            applicationServer: (count.applicationServer===true && techniquesPerAsset2.applicationServer.includes(allTechniques[technique]) && getScore(count.applicationServerQuantity) || ''),
            controlServer: (count.controlServer===true && techniquesPerAsset2.controlServer.includes(allTechniques[technique]) && getScore(count.controlServerQuantity) || ''),
            dataGateway: (count.dataGateway===true && techniquesPerAsset2.dataGateway.includes(allTechniques[technique]) && getScore(count.dataGatewayQuantity) || ''),
            dataHistorian: (count.dataHistorian===true && techniquesPerAsset2.dataHistorian.includes(allTechniques[technique]) && getScore(count.dataHistorianQuantity) || ''),
            fieldio: (count.fieldio===true && techniquesPerAsset2.fieldio.includes(allTechniques[technique]) && getScore(count.fieldioQuantity) || ''),
            hmi: (count.hmi===true && techniquesPerAsset2.hmi.includes(allTechniques[technique]) && getScore(count.hmiQuantity) || ''),
            ied: (count.ied===true && techniquesPerAsset2.ied.includes(allTechniques[technique]) && getScore(count.iedQuantity) || ''),
            jumpHost:(count.jumpHost===true && techniquesPerAsset2.jumpHost.includes(allTechniques[technique]) && getScore(count.jumpHostQuantity) || ''),
            plc: (count.plc===true && techniquesPerAsset2.plc.includes(allTechniques[technique]) && getScore(count.plcQuantity) || ''),
            routers: (count.routers===true && techniquesPerAsset2.routers.includes(allTechniques[technique]) && getScore(count.routersQuantity) || ''),
            rtu: (count.rtu===true && techniquesPerAsset2.rtu.includes(allTechniques[technique]) && getScore(count.rtuQuantity) || ''),
            safetyController: (count.safetyController===true && techniquesPerAsset2.safetyController.includes(allTechniques[technique]) && getScore(count.safetyControllerQuantity) || ''),
            vpnAsset: (count.vpnAsset===true && techniquesPerAsset2.vpnAsset.includes(allTechniques[technique]) && getScore(count.vpnAssetQuantity) || ''),
            workstations: (count.workstations===true && techniquesPerAsset2.workstations.includes(allTechniques[technique]) && getScore(count.workstationsQuantity) || ''),
            score: tempScore.toFixed(2)
          },
        )
      }

      let filteredList = tempList.filter(score => score.score !== "0.00");
      
      zoneData.push(
        new Paragraph({
          text: ``,
          style: "normalPara2",
        }),
        new Paragraph({
          text: `The table below shows the overall assessment score for ${allZoneData[zone]?.zoneName}.`,
          style: "normalPara2",
        }),
        new Table({
          rows: [
            new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  text: `Raw Score:  ${tempZoneScore?.toFixed(2)}`,

                }),
              ],
            }),
          new TableCell({
            children: [
              new Paragraph({
                text: `Protection Score:  ${((tempZoneScore / (filteredList.length))*100).toFixed(2) || ""}%`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
          new TableCell({
            children: [
              new Paragraph({
                text: `Total Attack Surface:  ${tempTotalZoneScore}`,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
          new TableCell({
            children: [
              new Paragraph({
                text: `Exposed Attack Surface:  ${((tempTotalZoneScore-tempZoneScore)?.toFixed(2)) || ""}`,  
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
            ],
        }),

            ],
            width: { size: 100, type: WidthType.PERCENTAGE },
            margins: {
              top: convertInchesToTwip(0.05),
              bottom: convertInchesToTwip(0.05),
              right: convertInchesToTwip(0.05),
              left: convertInchesToTwip(0.05),
              style: "wellSpaced"
          },
        }),)

      // console.log(tempList);
      // let filteredList = tempList.filter(score => score.score !== "0.00");
      let techniquesPerZoneRowData = [
        new TableRow({
            children: techniquesPerAssetRowHeader
          }),
      ];

      for (let index in filteredList) {
        // console.log(filteredList[index]);
        let rowData = [];
        for (let key in Object(filteredList[index])) {
          // console.log(filteredList[index][key]);
          if (columnFilterList.includes(key)) {
            if (key==="score") {
              rowData.push(
              new TableCell({
                children: [
                  new Paragraph({
                    text: `${filteredList[index][key]}`,
                  }),
                ],
                shading: {fill: (filteredList[index][key]<0.25 ? (
                  '#FC6B6B'
                ):(
                  filteredList[index][key]<0.5 ? (
                  '#FBA63D'
                  ):(
                    filteredList[index][key]<0.75 ? (
                      '#FBEC3D'
                    ):(
                      '#3DFBA0') )))},
              }),
            )
            } else
            rowData.push(
              new TableCell({
                children: [
                  new Paragraph({
                    text: `${filteredList[index][key]}`,
                  }),
                ],
              }),
            )
          }
        }
        techniquesPerZoneRowData.push(
          new TableRow({
          children: rowData
        })
        )
      };

      zoneDataForAppendix.push(
        new Paragraph({
          text: ``,
          style: "normalPara2",
        }),
        new Paragraph({
            text: `${allZoneData[zone]?.zoneName}`,
            heading: HeadingLevel.HEADING_4,
        }),
        new Paragraph({
          text: `The table below shows the protection scores for each asset by technique.`,
          style: "normalPara2",
        }),
        new Table ({ 
        rows: techniquesPerZoneRowData, 
        margins: {
          top: convertInchesToTwip(0.1),
          bottom: convertInchesToTwip(0.1),
          right: convertInchesToTwip(0.1),
          left: convertInchesToTwip(0.1),
        },
      }),
      new Paragraph({
          text: ``,
          style: "normalPara2",
        }),
      )

      // console.log(techniquesPerZoneRowData);


      // console.log(filteredList);
      // setTotalZoneAttackSurface(tempTotalZoneScore);
      // setColumns(tempColumns);
      // setRows(filteredList);
      // setZoneScore(tempZoneScore);
  }
}
}

useEffect(() => {
  getAssessmentData();
  getCriticalAssets();
  getThreatProfiles(); // used for Relative Risk Register
  getCorrectiveActions();
  getDam();
  getGeneral();
//*******BEGIN HYDRO CYBER CHECKLIST FUNCTION CALLS************/
  getInfoSecurityCoordinationResponsibilities();
  getSystemLifecycle();
  getSystemRestorationRecovery();
  getIntrusionDetectionResponse();
  getTraining();
  getAccessControlFunctionalSegregation();
  getAccessControl();
  getCyberAssets();
  getZones();
//*******END HYDRO CYBER CHECKLIST FUNCTION CALLS************/
}, [refresh]);  // eslint-disable-line react-hooks/exhaustive-deps
// if (!rows) {
//   return null;
// }



//*****************************BEGIN RELATIVE RISK REGISTER SCORE LIST CREATION******************/

  const getSecurityScore = (index) => {
  const securityAssessmentScoreFoot = index.externalAccess + index.physicalSecurity + index.detection + index.delay + index.response + index.responseTime + index.assessmentExternal + index.assessmentInternal + index.securityAssessment + index.securityPlan + index.cybersecurity; // + index.cpme + index.cdpr;
  const securityAssessmentScoreVehicle = index.externalAccessVehicle + index.physicalSecurityVehicle + index.detectionVehicle + index.delayVehicle + index.responseVehicle + index.responseTimeVehicle + index.assessmentExternalVehicle + index.assessmentInternalVehicle + index.securityAssessmentVehicle + index.securityPlanVehicle + index.cybersecurityVehicle; // + index.cpme + index.cdpr;
  const securityScore = Math.round((((securityAssessmentScoreFoot + securityAssessmentScoreVehicle) / 2) * 10) / 44);
  return (
    securityScore
  );
};


const createScoresLists = () => {
  
  for (let index in criticalDamAssets) {
    let threatScore = 0;
    let vulnerabilityScore = 0;
    let consequenceScore = 0;
    let likelihoodScore = 0;
    let relativeRiskScore = 0;
    let c = 0;
      for (let count in threatProfiles) {
        if (criticalDamAssets[index]._id===threatProfiles[count].criticalAssetID) {
          c = c + 1;
          threatScore = threatProfiles[count].threatValue + threatScore;
          vulnerabilityScore = threatProfiles[count].vulnerabilityValue + vulnerabilityScore;
          consequenceScore = threatProfiles[count].consequenceValue + consequenceScore;
          likelihoodScore = threatProfiles[count].likelihoodValue + likelihoodScore;
        }
      }
      if (consequenceScore === 0 ) {
        consequenceScore = 1;
      }
      

      if (c !== 0) {
        threatScore = Math.round(threatScore / c);
        vulnerabilityScore= Math.round(vulnerabilityScore / c);
        consequenceScore = Math.round(consequenceScore / c);
        likelihoodScore = Math.round(likelihoodScore / c);
        relativeRiskScore = Math.round(threatScore + vulnerabilityScore + likelihoodScore);
        if (criticalDamAssets[index].security === 10) {
          relativeRiskScore = ((consequenceScore * relativeRiskScore) / 300);
        } else {
          relativeRiskScore = (((consequenceScore * relativeRiskScore) / (10-criticalDamAssets[index].security))/300);
        }
        criticalDamAssets[index].threats = threatScore;
        criticalDamAssets[index].vulnerabilities = vulnerabilityScore;
        criticalDamAssets[index].consequences = consequenceScore;
        criticalDamAssets[index].likelihoods = likelihoodScore;
        criticalDamAssets[index].relativeRisk = relativeRiskScore.toFixed(1);
      } else {
        criticalDamAssets[index].threats = threatScore;
        criticalDamAssets[index].vulnerabilities = vulnerabilityScore;
        criticalDamAssets[index].consequences = consequenceScore;
        criticalDamAssets[index].likelihoods = likelihoodScore;
        criticalDamAssets[index].relativeRisk = relativeRiskScore.toFixed(1);
      }
  }
};


criticalDamAssets?.forEach(object => {
  object.security = getSecurityScore(object);
});
  
createScoresLists();

//*****************************END RELATIVE RISK REGISTER SCORE LIST CREATION******************/

//*************BEGIN HYDRO CYBER CHECKLIST QUESTIONS AND COLUMNS ASSIGNMENT*****************/

const mutateAnswer = (args) => {
    if (args != null) {
      if (args === 'true') {
        return 'Yes'
      }
      else return 'No'
    }
    else return 'Not answered';
  }

  // const FERCHydroCyberSCADASecurityChecklistForm3 = [
    const form3Rows = [
    {
      id: '1',
      question: 'Does the facility/project utilize automated or remote (off-site) control of data acquisition, such as critical instrumentation or operation data?',
      answer: remoteAccess,
      comments: remoteAccessComments
    },
    {
      id: '2',
      question: 'Does the facility/project utilize automated or remote control of power generation data or power generation controls?',
      answer: remoteAccess,
      comments: remoteAccessComments
    },
    {
      id: '3',
      question: 'Does the facility/project utilize automated or remote control of water management data or direct control of water retention features?',
      answer: remoteAccess,
      comments: remoteAccessComments
    },
    {
      id: '4',
      question: 'Is there an interconnection of computer Systems from/to this facility/project to other dam(s)?',
      answer: remoteAccessConnected,
      comments: "None"
    },
    {
      id: '5',
      question: 'Are other FERC regulated projects controlled by this facility?',
      answer: mutateAnswer(hasOtherFERCProjects),
      comments: ""
    },
    {
      id: '6',
      question: 'Are physical protection measures in place for the control room/facility?',
      answer: "NOT ANSWERED YET.",
      comments: "NONE YET"
    },
    {
      id: '7a',
      question: 'Does the facility/project have a separate Cyber/Industrial Control System (e.g. SCADA) Security Plan?',
      answer: mutateAnswer(hasCybersecurityPlan),
      comments: cybersecurityPlanName
    },
    {
      id: '7b',
      question: 'If not, is Cyber/Industrial Control System (e.g. SCADA) Security included in another plan?',
      answer: mutateAnswer(hasCybersecurityPlan),
      comments: cybersecurityPlanName
    },
    {
      id: '8a',
      question: 'Does the project have any (hydroelectric) cyber assets which are subject to NERC-CIP Standards?',
      answer: mutateAnswer(nERCCIPApplies),
      comments: ""
    },
    {
      id: '8b',
      question: 'If a NERC-CIP compliance audit has been performed, have all identified deficiencies been addressed?',
      answer: mutateAnswer(nERCCIPFindingsAddressed),
      comments: ""
    },
    {
      id: '9a',
      question: 'Have all facility/project Cyber/ICS assets been inventoried/identified?',
      answer: mutateAnswer(hasInventory),
      comments: ""
    },
    {
      id: '9b',
      question: 'Have the assets been designated as critical, operational, or non-critical?',
      answer: mutateAnswer(hasFERCDesignation),
      comments: ""
    },
    {
      id: '10',
      question: 'Does the facility/project have Business Cyber Assets (non-industrial control systems which include corporate email, human resources, company website, etc.)?',
      answer: mutateAnswer(hasBusinessCyberAssets),
      comments: ""
    },
    {
      id: '11a',
      question: 'Are the Industrial Control System (e.g. SCADA) and non-Industrial Control System networks segregated and access controls applied to prevent unauthorized communication between these networks?',
      answer: mutateAnswer(hasSegmentedITOTNetworks),
      comments: hasSegmentedCriticalAssetsComments
    },
    {
      id: '11b',
      question: 'Within the Industrial Control System environment (to include building services such as HVAC) are the networks segregated and access controls applied to prevent unauthorized communication between these networks?',
      answer: mutateAnswer(doesDataCommNetwork),
      comments: doesDataCommNetworkComments,
    },
    {
      id: '12a',
      question: 'Do any vendors or 3rd parties have remote access to your network?',
      answer: mutateAnswer(has3rdPartyRemoteAccess),
      comments: has3rdPartyRemoteAccessComments
    },
    {
      id: '12b',
      question: 'If yes, are access controls implemented to prevent and monitor for unauthorized attempts and access to systems and operations?',
      answer: mutateAnswer(doesRemoteConnectionWeeklyReview),
      comments: doesRemoteConnectionWeeklyReviewComments
    },
    {
      id: '12c',
      question: 'If yes, is activity logged and reviewed at least weekly?',
      answer: mutateAnswer(doesRemoteConnectionWeeklyReview),
      comments: doesRemoteConnectionWeeklyReviewComments
    },
    {
      id: '13a',
      question: 'Does the facility/project utilize wireless in the Cyber/SCADA system?',
      answer: mutateAnswer(hasSCADAWireless),
      comments: hasSCADAWirelessComments
    },
    {
      id: '13b',
      question: 'If yes, are access controls implemented to prevent and monitor for unauthorized attempts and access to systems and operations? ',
      answer: mutateAnswer(hasWirelessAccessControl),
      comments: hasWirelessAccessControlComments
    },
    {
      id: '14a',
      question: 'Are cyber security controls implemented within the ICS network that allow for logging, monitoring, detection, and isolation of an anomalous cyber event?',
      answer: mutateAnswer(hasIntrusionDetectionResponsePolicy),
      comments: hasIntrusionDetectionResponsePolicyComments,
    },

    {
      id: '14b',
      question: 'Is there a dedicated team to review the information?',
      answer: mutateAnswer(hasDedicatedSecMonTeam),
      comments: hasDedicatedSecMonTeamComments
    },
    {
      id: '14c',
      question: 'How often does the review occur?',
      answer: mutateAnswer(doesSecurityLogReviewFrequency),
      comments: doesSecurityLogReviewFrequencyComments,
    },{
      id: '15',
      question: 'Is a configuration and patch management program established for both ICS and non-ICS networks?',
      answer: mutateAnswer(hasConfigurationManagement),
      comments: hasConfigurationManagementComments,
    },
    {
      id: '16',
      question: 'Does a back-up site exist and are systems routinely backed-up for ICS and non-ICS networks?',
      answer: mutateAnswer(hasBackupSite),
      comments: hasBackupSiteComments,
    },
    {
      id: '17',
      question: 'Do you have a policy to address removable and portable media?',
      answer: mutateAnswer(hasRemovableMediaPolicy),
      comments: ""
    },
    {
      id: '18a',
      question: 'With respect to Tables 9.3a of the Security Guidance, are “General” baseline cyber security measures being implemented?',
      answer: generalMeasure,
      // comments: hasLogicalAccessControlComments + knowsAssetCriticalityComments + doesAnnualPolicyReviewComments + doesApproveNetworkConnectionsComments + doesAssessWirelessUseComments
      // comments: generalMeasureComments
    },
    {
      id: '18a1',
      question: 'Do you restrict logical access to control systems and networks through the use of passwords, secured communication gateways (jump boxes), access control lists, authenticators, and/or other secure access methods?',
      answer: mutateAnswer(hasLogicalAccessControl),
      comments: hasLogicalAccessControlComments
    },
    {
      id: '18a2',
      question: 'Do you review and reassess cyber asset criticality (non-critical, operational, critical) at least every 12 months?',
      answer: mutateAnswer(knowsAssetCriticality),
      comments: knowsAssetCriticalityComments
    },
    {
      id: '18a3',
      question: 'Do you review and update your cyber security policies and/or procedures annually?',
      answer: mutateAnswer(doesAnnualPolicyReview),
      comments: doesAnnualPolicyReviewComments
    },
    {
      id: '18a4',
      question: 'Do you monitor and review (at least every 18months) network connections, including remote and third-party connections?',
      answer: mutateAnswer(doesApproveNetworkConnections),
      comments: doesApproveNetworkConnectionsComments
    },
    {
      id: '18a5',
      question: 'Did you conduct a risk assessment before implementing wireless networking?',
      answer: mutateAnswer(doesAssessWirelessUse),
      comments: doesAssessWirelessUseComments
    },
    {
      id: '18b',
      question: 'Are “Information Security Coordination & Responsibilities” baseline cyber security measures being implemented?',
      answer: infoSecurityCoordinationResponsibilities,
      // comments: hasCybersecurityTeamComments + hasCyberRolesResponsibilitiesComments + hasInternalCommunicationPlanComments + doesExternalCommunicationPlanComments + includesSupplyChainRiskManagementComments
    },
    {
      id: '18b1',
      question: 'Do you have a dedicated cyber security team?',
      answer: mutateAnswer(hasCybersecurityTeam),
      comments: hasCybersecurityTeamComments
    },
    {
      id: '18b2',
      question: 'Have you defined cyber security roles and responsibilities?',
      answer: mutateAnswer(hasCyberRolesResponsibilities),
      comments: hasCyberRolesResponsibilitiesComments
    },
    {
      id: '18b3',
      question: 'Do you have established lines of communication among the cyber security team, operations, IT, and business groups?',
      answer: mutateAnswer(hasInternalCommunicationPlan),
      comments: hasInternalCommunicationPlanComments
    },
    {
      id: '18b4',
      question: 'Do your lines of communication include outsourcers, partners, and third-parties?',
      answer: mutateAnswer(doesExternalCommunicationPlan),
      comments: doesExternalCommunicationPlanComments
    },
    {
      id: '18b5',
      question: 'Does your risk management strategy address cybersecurity supply chain risks?',
      answer: mutateAnswer(includesSupplyChainRiskManagement),
      comments: includesSupplyChainRiskManagementComments
    },
    {
      id: '18c',
      question: 'Are “System Lifecycle” baseline cyber security measures being implemented',
      answer: systemLifecycle,
      // comments: doesRemoveConfigsComments + hasConfigurationManagementComments + hasSecureDesignPrinciplesComments
    },
    {
      id: '18c1',
      question: 'Are operational data/configurations removed from systems before they are decommissioned?',
      answer: mutateAnswer(doesRemoveConfigs),
      comments: doesRemoveConfigsComments
    },
    {
      id: '18c2',
      question: 'Is a configuration and patch management program established for both ICS and non-ICS networks?',
      answer: mutateAnswer(hasConfigurationManagement),
      comments: hasConfigurationManagementComments
    },
    {
      id: '18c3',
      question: 'Do you follow secure design principles (security architecture principles) when building a new system or modifying an existing system?',
      answer: mutateAnswer(hasSecureDesignPrinciples),
      comments: hasSecureDesignPrinciplesComments
    },
    {
      id: '18d',
      question: 'Are “System Restoration & Recovery” baseline cyber security measures being implemented?',
      answer: systemRestorationRecovery,
      // comments: hasRestorationRecoveryPlanComments + doesTestRestorationRecoveryPlanComments + hasBackupSiteComments
    },
    {
      id: '18d1',
      question: 'Do you have restoration and recovery of plan for control systems?',
      answer: mutateAnswer(hasRestorationRecoveryPlan),
      comments: hasRestorationRecoveryPlanComments
    },
    {
      id: '18d2',
      question: 'Do you review, update, and test the plan at least annually?',
      answer: mutateAnswer(doesTestRestorationRecoveryPlan),
      comments: doesTestRestorationRecoveryPlanComments
    },
    {
      id: '18d3',
      question: 'Does a back-up site exist and are systems routinely backed-up for ICS and non-ICS networks?',
      answer: mutateAnswer(hasBackupSite),
      comments: hasBackupSiteComments
    },
    {
      id: '18e',
      question: 'Are “Intrusion Detection & Response” baseline cyber security measures being implemented?',
      answer: mutateAnswer(intrustionDetectionResponse),
      // comments: hasIntrusionDetectionResponsePolicyComments + hasIDRControlsImplementedComments
    },
    {
      id: '18e1',
      question: 'Do you maintain plans, procedures, and technologies to detect, analyze, and respond to cybersecurity events (and their physical protection)?',
      answer: mutateAnswer(hasIntrusionDetectionResponsePolicy),
      comments: hasIntrusionDetectionResponsePolicyComments
    },
    {
      id: '18e2',
      question: 'Are cyber security controls implemented within the ICS network that allow for Logging?',
      answer: mutateAnswer(doesLogging),
      comments: hasIDRControlsImplementedComments
    },
    {
      id: '18e2i',
      question: 'Are cyber security controls implemented within the ICS network that allow for Monitoring?',
      answer: mutateAnswer(doesMonitoring),
      comments: ""
    },
    {
      id: '18e2ii',
      question: 'Are cyber security controls implemented within the ICS network that allow for Detection?',
      answer: mutateAnswer(doesDetection),
      comments: ""
    },
    {
      id: '18e2iii',
      question: 'Are cyber security controls implemented within the ICS network that allow for Isolation of Anomalies?',
      answer: mutateAnswer(doesAnomalyIsolation),
      comments: ""
    },
    {
      id: '18f',
      question: 'Are “Training” baseline cyber security measures being implemented?',
      answer: mutateAnswer(training),
      // comments: hasUserTrainingRequirementComments + hasAnnualUserTrainingComments + hasSecurityRoleSpecificTrainingComments
    },
    {
      id: '18f1',
      question: 'Are control system users provided information security awareness before they are allowed to access control systems?',
      answer: mutateAnswer(hasUserTrainingRequirement),
      comments: hasUserTrainingRequirementComments
    },
    {
      id: '18f2',
      question: 'Are control system users provided information security awareness training at least annually?',
      answer: mutateAnswer(hasAnnualUserTraining),
      comments: hasAnnualUserTrainingComments
    },
    {
      id: '18f3',
      question: 'Are users with significant control systems secuirty roles given advanced training specific to their role?',
      answer: mutateAnswer(hasSecurityRoleSpecificTraining),
      comments: hasSecurityRoleSpecificTrainingComments
    },
    {
      id: '18g',
      question: 'With respect to the tables in Section 9.3a, are “Access Control & Functional Segregation” baseline cyber security measures being implemented?',
      answer: mutateAnswer(accessControlFunctionalSegregation),
      comments: hasPolicyComments + hasLogicalAccessControlComments + hasSegmentedITOTNetworksComments + hasUserAgreementComments
    },
    {
      id: '18g1',
      question: 'Do you have an Access Control Policy',
      answer: mutateAnswer(hasAccessControlPolicy),
      comments: ""
    },
    {
      id: '18g1i',
      question: 'Do you have an Asset Management Policy',
      answer: mutateAnswer(hasAssetManagementPolicy),
      comments: ""
    },
    {
      id: '18g1ii',
      question: 'Do you have a Configuration Management Policy',
      answer: mutateAnswer(hasConfigurationManagementPolicy),
      comments: ""
    },
    {
      id: '18g1iii',
      question: 'Do you have a Supply Chain Risk Management Policy',
      answer: mutateAnswer(hasSupplyChainRiskManagementPolicy),
      comments: ""
    },
    {
      id: '18g1iv',
      question: 'Do you have a Removable Media Policy',
      answer: mutateAnswer(hasRemovableMediaPolicy),
      comments: ""
    },
    {
      id: '18g2',
      question: 'Do you restrict logical access to control systems and networks through the use of passwords, secured communication gateways (jump boxes), access control lists, authenticators, and/or other secure access methods?',
      answer: mutateAnswer(hasLogicalAccessControl),
      comments: hasLogicalAccessControlComments
    },
    {
      id: '18g3',
      question: 'Are the Industrial Control System (e.g. SCADA) and non-Industrial Control System networks segregated and access controls applied to prevent unauthorized communication between these networks?',
      answer: mutateAnswer(hasSegmentedITOTNetworks),
      comments: hasSegmentedCriticalAssetsComments
    },
    {
      id: '18g4',
      question: 'Do users know to only use cyber assets for approved activities, such as through a signed User Agreement?',
      answer: mutateAnswer(hasUserAgreement),
      comments: hasUserAgreementComments
    },
    {
      id: '18h',
      question: 'With respect to Tables 9.3b of the Security Guidance, are “Access Control” enhanced cyber security measures being implemented?',
      answer: mutateAnswer(accessControl),
      // comments: hasLogicalAccessControlComments + doesAssessWirelessUseComments
    },
    {
      id: '18h1',
      question: 'Do you restrict logical access to control systems and networks through the use of passwords, secured communication gateways (jump boxes), access control lists, authenticators, and/or other secure access methods?',
      answer: mutateAnswer(hasLogicalAccessControl),
      comments: hasLogicalAccessControlComments
    },
    {
      id: '18h2',
      question: 'Did you conduct a risk assessment before implementing wireless networking?',
      answer: mutateAnswer(doesAssessWirelessUse),
      comments: doesAssessWirelessUseComments
    },
    {
      id: '18i',
      question: 'Are “Vulnerability Assessment” enhanced cyber security measures being implemented?',
      answer: mutateAnswer(doesPeriodicRiskAssessments),
      comments: doesPeriodicRiskAssessmentsComments
    },
    {
      id: '19a',
      question: 'Do you maintain an inventory of your technology systems, software, and assets?',
      answer: mutateAnswer(hasInventory),
      comments: "",
    },
    {
      id: '19b',
      question: 'Is operational data/configurations removed from systems before they are decommissioned?',
      answer: mutateAnswer(doesRemoveConfigs),
      comments: doesRemoveConfigsComments,
    },
    {
      id: '20',
      question: 'Have you identified the systems, assets, information, and processes that are essential to your organizational mission?',
      answer: mutateAnswer(missionEssentialAssetsIdentified),
      comments: ""
    },
    {
      id: '21',
      question: 'Do you have appropriate access control policies and procedures in place for all systems and assets with particular focus on those that are critical?',
      answer: mutateAnswer(hasAccessControlPolicy),
      comments: hasLogicalAccessControlComments
    },
    {
      id: '22',
      question: 'Are your critical systems and assets appropriately separated or secured from your non-critical systems and assets?',
      answer: mutateAnswer(hasSegmentedCriticalAssets),
      comments: hasSegmentedCriticalAssetsComments
    },
    {
      id: '23a',
      question: 'Do you assess the threats to your organization and the resources available for an appropriate defense?',
      answer: mutateAnswer(doesThreatAssessment),
      comments: doesThreatAssessmentComments
    },
    {
      id: '23b',
      question: 'Do you perform this assessment independently? ',
      answer: mutateAnswer(doesIndependentThreatAssessment),
      comments: doesIndependentThreatAssessmentComments
    },
    {
      id: '24a',
      question: 'Do you assess the resources available to govern and implement your security strategy?',
      answer: mutateAnswer(doesResourceAssessment),
      comments: doesResourceAssessmentComments
    },
    {
      id: '24b',
      question: 'Do you perform this assessment independently?',
      answer: mutateAnswer(doesIndependentResourceAssessment),
      comments: doesIndependentResourceAssessmentComments
    },
    {
      id: '25a',
      question: 'Do you maintain plans, procedures, and technologies to detect, analyze, and respond to cybersecurity events (and their physical protection)?',
      answer: mutateAnswer(hasIntrusionDetectionResponsePolicy),
      comments: hasIntrusionDetectionResponsePolicyComments
    },
    {
      id: '25b',
      question: 'Do these include notifying with law enforcement and government security agencies?',
      answer: mutateAnswer(doesNotifyLawEnforcement),
      comments: doesNotifyLawEnforcementComments
    },
    {
      id: '26a',
      question: 'Do you routinely exercise your cyber response plans and procedures?',
      answer: mutateAnswer(doesExerciseResponsePlans),
      comments: doesExerciseResponsePlansComments
    },
    {
      id: '26b',
      question: 'Does this include working with law enforcement and government security agencies?',
      answer: mutateAnswer(includesExerciseWithLawEnforcement),
      comments: includesExerciseWithLawEnforcementComments
    },
    {
      id: '27a',
      question: 'Do you perform post-event analysis?',
      answer: mutateAnswer(doesPostEventAnalysis),
      comments: doesPostEventAnalysisComments
    },
    {
      id: '27b',
      question: 'Does this include working with law enforcement and government security agencies?',
      answer: mutateAnswer(includesAnalysisWithLawEnforcement),
      comments: includesAnalysisWithLawEnforcementComments
    },
    {
      id: '28',
      question: 'Do you incorporate lessons learned into your policies, plans, and procedures?',
      answer: mutateAnswer(incorporatesIDRLessonedLearned),
      comments: incorporatesIDRLessonedLearnedComments
    },
    {
      id: '29',
      question: 'Do you have an enterprise-wide all-hazards risk management strategy?',
      answer: mutateAnswer(hasRiskManagementStrategy),
      comments: hasRiskManagementStrategyComments
    },
    {
      id: '30',
      question: 'Are your operations, cyber, and physical security teams engaged in your risk management strategy?',
      answer: mutateAnswer(hasOrgWideRiskParticipation),
      comments: hasOrgWideRiskParticipationComments
    },
    {
      id: '31',
      question: 'Do you periodically conduct risk assessments, including outsourced vulnerability assessments, and are the results reported to you?',
      answer: mutateAnswer(doesPeriodicRiskAssessments),
      comments: doesPeriodicRiskAssessmentsComments
    },
    {
      id: '32a',
      question: 'Does your risk management strategy address cybersecurity supply chain risks?',
      answer: mutateAnswer(includesSupplyChainRiskManagement),
      comments: includesSupplyChainRiskManagementComments
    },
    {
      id: '32b',
      question: 'Does your risk management strategy address insider threat risks?',
      answer: mutateAnswer(addressesInsiderThreat),
      comments: addressesInsiderThreatComments
    },
    {
      id: '33a',
      question: 'Do you maintain and integrate situational awareness of operations, cyber and physical threats?',
      answer: mutateAnswer(hasSituationAwareness),
      comments: hasSituationAwarenessComments
    },
    {
      id: '33b',
      question: 'Do you maintain informational sharing relationships with external entities (both government and commercial) to collect and provide cybersecurity and physical security information?',
      answer: mutateAnswer(hasInformationSharing),
      comments: hasInformationSharingComments,
    }
  ];

  const Form3RowsForReport = () => {
  if (form3Rows) {

  
  for (let index in form3Rows) {
  form3List.push(new TableRow({ children: [ 
    new TableCell({ children: [new Paragraph({text: form3Rows[index]?.id, style: "wellSpaced"})]}), 
    new TableCell({ children: [new Paragraph({text: form3Rows[index]?.question, style: "wellSpaced"})] }), 
    new TableCell({ children: [new Paragraph({text: form3Rows[index]?.answer, style: "wellSpaced"})]}),
    new TableCell({ children: [new Paragraph({text: form3Rows[index]?.comments, style: "wellSpaced"})]}),
       ]
      })
    )
  }
} 
};

  //*************END HYDRO CYBER CHECKLIST QUESTIONS AND COLUMNS ASSIGNMENT*****************/

// console.log(criticalDamAssets);
  //*************BEGIN RELATIVE RISK SCORE TABLE ROW CREATION*****************/
  const CriticalAssetRiskScoresForReport = () => {
    for (let index in criticalDamAssets) {
      relativeRiskScoreList?.push( new TableRow({ children: [ 
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.assetName, style: "wellSpaced"})]}), 
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.security.toString(), style: "wellSpaced"})] }), 
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.consequences.toString(), style: "wellSpaced"})]}),
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.vulnerabilities.toString(), style: "wellSpaced"})]}),
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.likelihoods.toString(), style: "wellSpaced"})] }), 
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.threats.toString(), style: "wellSpaced"})]}),
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.relativeRisk, style: "wellSpaced"})]}),
        new TableCell({ children: [new Paragraph({text: criticalDamAssets[index]?.riskManagementDecision, style: "wellSpaced"})]}),
       ]
      })
      )
    }
  };
  //*************END RELATIVE RISK SCORE TABLE ROW CREATION*****************/


// console.log(relativeRiskScoreList);


 CriticalAssetsListForReport();
 CorrectiveActionsforReport();
 Form3RowsForReport();
 CriticalAssetRiskScoresForReport();
 ZoneDataForReport();
//  console.log(criticalDamAssets);
//  console.log(criticalAssetItems);
 
  // const rows = actionsList3;
//  const table3 = new Table ({ rows: criticalAssetItems });


 const securityAssessmentToolResultsTable = new Table ({ 
  alignment: AlignmentType.CENTER,
  rows: assessmentToolResults,
  margins: {
    top: convertInchesToTwip(0.1),
    bottom: convertInchesToTwip(0.1),
    right: convertInchesToTwip(0.1),
    left: convertInchesToTwip(0.1),
  },
});
 const correctiveActionsTable = new Table ({ 
  rows: correctiveActionsList, 
  margins: {
    top: convertInchesToTwip(0.1),
    bottom: convertInchesToTwip(0.1),
    right: convertInchesToTwip(0.1),
    left: convertInchesToTwip(0.1),
  },
});

const form3Table = new Table ({ 
  rows: form3List, 
  margins: {
    top: convertInchesToTwip(0.1),
    bottom: convertInchesToTwip(0.1),
    right: convertInchesToTwip(0.1),
    left: convertInchesToTwip(0.1),
  },
});

const criticalAssetTableRelativeRiskScores = new Table ({ 
  rows: relativeRiskScoreList,
  margins: {
    top: convertInchesToTwip(0.1),
    bottom: convertInchesToTwip(0.1),
    right: convertInchesToTwip(0.1),
    left: convertInchesToTwip(0.1),
}
   || [new TableRow({ children: [ new TableCell({ children: [new Paragraph({text: "See Attachment",  style: "normalPara2", bullet: {level: 0}})], borders: {
  top: {
      style: BorderStyle.NONE,
      size: 1,
      // color: "FF0000",
  },
  bottom: {
      style: BorderStyle.NONE,
      size: 1,
      // color: "0000FF",
  },
  left: {
      style: BorderStyle.NONE,
      size: 1,
      // color: "00FF00",
  },
  right: {
      style: BorderStyle.NONE,
      size: 1,
      // color: "#ff8000",
  },
}, }) ]
})] });


// console.log(damData?.damName);


// *********************** START TABLES FOR FERC HYDRO SECURITY CHECKLIST V5 
const backgroundColorDetectionAssessment = "#f4f765";
const backgroundColorDelay = "#66f2a9";
const backgroundColorResponse = "#9cd8f4";
const backgroundColorIntegrationRiskManagement = "#e2eae9";
const cellMarginSet = 0.5;

// DETECTION ASSESSMENT TABLE
const tableDetectionAssessment = new Table({
  rows: [
      new TableRow({
          children: [
              new TableCell({
                children: [new Paragraph("Field Observations: (Provide detailed supplemental information to the right)")],
              }),
              new TableCell({
                children: [new Paragraph("Answer")],
              }),
              new TableCell({
                children: [new Paragraph("Comments (Provide additional details – especially any “No” answers – here and separate sheets, if necessary. Indicate NA if not appropriate to site.) ")],
              }),
              // new TableCell({
              //   children: [new Paragraph("Test cell 1.")],
              // }),
              // new TableCell({
              //   children: [new Paragraph("Test cell 1.")],
              // }),
          ], 
          
      }),
      new TableRow ({
        children: [ 
          new TableCell({
            children: [new Paragraph({text: "DETECTION AND ASSESSMENT", heading: HeadingLevel.HEADING_3})],
            columnSpan: 3,
            shading: {
              fill: backgroundColorDetectionAssessment
            }
          })
        ]
      }),
      new TableRow({
          children: [
              new TableCell({
                  children: [new Paragraph("1a. Is the dam manned?")], 
                  shading: {
                    fill: backgroundColorDetectionAssessment
                  }
              }),
              new TableCell({
                children: [new Paragraph(damManned || "")],
                shading: {
                  fill: backgroundColorDetectionAssessment
                }
              }),
              new TableCell({
                children: [
                  new Paragraph(`How many days per week? ${damMannedCommentsDaysWeek}`),
                  new Paragraph(`How many hours per day? ${damMannedCommentsHoursDay}`),
                  new Paragraph(`Additional Comments: ${damMannedComments}`),
                ],
                shading: {
                  fill: backgroundColorDetectionAssessment
                }
              }),
          ]
      }),
      new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph("1b. Is the powerhouse manned")],
              shading: {
                fill: backgroundColorDetectionAssessment
              }
          }),
          new TableCell({
            children: [new Paragraph(powerhouseManned || "")],
            shading: {
              fill: backgroundColorDetectionAssessment
            }
          }),
          new TableCell({
            children: [
              new Paragraph(`How many days per week? ${powerhouseMannedCommentsDaysWeek}`),
              new Paragraph(`How many hours per day? ${powerhouseMannedCommentsHoursDay}`),
              new Paragraph(powerhouseMannedComments || ""),
            ],
            shading: {
              fill: backgroundColorDetectionAssessment
            }
          }),
          ],
      }),
      new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph("2a. Are there surveillance cameras in use at the Dam? ")],
              shading: {
                fill: backgroundColorDetectionAssessment
              }
          }),
          new TableCell({
            children: [new Paragraph(damSurveillanceCameras || "")],
            shading: {
              fill: backgroundColorDetectionAssessment
            }
          }),
          new TableCell({
            children: [new Paragraph(damSurveillanceCamerasComments || "")],
            shading: {
              fill: backgroundColorDetectionAssessment
            }
          }),
          ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("2b. Are there surveillance cameras in use at the powerhouse? ")],
            shading: {
              fill: backgroundColorDetectionAssessment
            }
        }),
        new TableCell({
          children: [new Paragraph(powerhouseSurveillanceCameras || "")],
          shading: {
            fill: backgroundColorDetectionAssessment
          }
        }),
        new TableCell({
          children: [new Paragraph(powerhouseSurveillanceCamerasComments || "")],
          shading: {
            fill: backgroundColorDetectionAssessment
          }
        }),
        ],
    }),
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("3. Is the frequency of walking inspections appropriate (safety and / or security)? ")],
          shading: {
            fill: backgroundColorDetectionAssessment
          }
      }),
      new TableCell({
        children: [new Paragraph(walkingInspections || "")],
        shading: {
          fill: backgroundColorDetectionAssessment
        }
      }),
      new TableCell({
        children: [new Paragraph(walkingInspectionsComments || "")],
        shading: {
          fill: backgroundColorDetectionAssessment
        }
      }),
      ],
  }),
  ],
  margins: {
    top: convertInchesToTwip(0.05),
    bottom: convertInchesToTwip(0.05),
    right: convertInchesToTwip(0.05),
    left: convertInchesToTwip(0.05),
},
});

// DELAY TABLE
const tableDelay = new Table({
  rows: [
      new TableRow({
          children: [
              new TableCell({
                children: [new Paragraph("Field Observations: (Provide detailed supplemental information to the right)")],
              }),
              new TableCell({
                children: [new Paragraph("Answer")],
                columnSpan: 2,
              }),
              new TableCell({
                children: [new Paragraph("Comments (Provide additional details – especially any “No” answers – here and separate sheets, if necessary. Indicate NA if not appropriate to site.) ")],
              }),
              // new TableCell({
              //   children: [new Paragraph("Test cell 1.")],
              // }),
              // new TableCell({
              //   children: [new Paragraph("Test cell 1.")],
              // }),
          ], 
          
      }),
      new TableRow ({
        children: [ 
          new TableCell({
            children: [new Paragraph({text: "DELAY", heading: HeadingLevel.HEADING_3})],
            columnSpan: 4,
            shading: {
              fill: backgroundColorDelay
            }
          }),
          
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("4. Is the dam site fenced with gates/doors locked (if appropriate to the site)?")],
            shading: {
              fill: backgroundColorDelay
            }
        }),
        new TableCell({
          children: [new Paragraph(lockedFence || "")],
          columnSpan: 2,
          shading: {
            fill: backgroundColorDelay
          }
        }),
        new TableCell({
          children: [
            new Paragraph(lockedFenceComments || ""),
          ],
          shading: {
            fill: backgroundColorDelay
          }
        }),
        ],
    }),
      new TableRow({
          children: [
              new TableCell({
                  children: [
                    new Paragraph("5. Are access restrictions to the dam and powerhouse sufficient to prevent the following types of attackers? ")
                  ],
                  rowSpan: 3,
                  shading: {
                    fill: backgroundColorDelay
                  }
              }),
              new TableCell({
                children: [
                  new Paragraph("Attacker on Foot:")
                ],
                shading: {
                  fill: backgroundColorDelay
                }
              }),
              new TableCell({
                children: [
                  new Paragraph(accessRestrictionsFoot || "")
                ],
                shading: {
                  fill: backgroundColorDelay
                }
              }),
              new TableCell({
                children: [
                  new Paragraph(accessRestrictionsFootComments || "")
                ],
                shading: {
                  fill: backgroundColorDelay
                }
              }),
          ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph("Attacker in a Vehicle:")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(accessRestrictionsVehicle || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(accessRestrictionsVehicleComments || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph("Attacker in a Boat:")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(accessRestrictionBoat || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(accessRestrictionBoatComments || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
        ],
      }),
      
      new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph("6. Are spillway gate controls secured against unauthorized access? ")],
              shading: {
                fill: backgroundColorDelay
              }
          }),
          new TableCell({
            children: [new Paragraph(spillwayGatesUnauthorizeAccess || "")],
            columnSpan: 2,
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [new Paragraph(spillwayGatesUnauthorizeAccessComments || "")],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          ],
      }),

      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("7a. Which of the following systems protect powerhouse doors and windows? ")
            ],
            rowSpan: 3,
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph("Locked")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(powerhouseDoorsWindowsLocked || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(powerhouseDoorsWindowsLockedComments || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph("Alarms")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(powerhouseAlarms || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
          new TableCell({
            children: [
              new Paragraph(powerhouseAlarmsComments || "")
            ],
            shading: {
              fill: backgroundColorDelay
            }
          }),
        ],
    }),
    new TableRow({
      children: [
        new TableCell({
          children: [
            new Paragraph("Motion Detectors:")
          ],
          shading: {
            fill: backgroundColorDelay
          }
        }),
        new TableCell({
          children: [
            new Paragraph(powerhouseMotionDetectors || "")
          ],
          shading: {
            fill: backgroundColorDelay
          }
        }),
        new TableCell({
          children: [
            new Paragraph(powerhouseMotionDetectorsComments || "")
          ],
          shading: {
            fill: backgroundColorDelay
          }
        }),
      ],
    }),
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("7b. Can these systems be easily bypassed? ")],
          shading: {
            fill: backgroundColorDelay
          }
      }),
      new TableCell({
        children: [new Paragraph(delaySystemsBypass || "")],
        columnSpan: 2,
        shading: {
          fill: backgroundColorDelay
        }
      }),
      new TableCell({
        children: [new Paragraph(delaySystemsBypassComments || "")],
        shading: {
          fill: backgroundColorDelay
        }
      }),
    ],
  }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("8. Which of the following physical security measures apply to the water conveyance system? ")],
            rowSpan: 2,
            shading: {
              fill: backgroundColorDelay
            }
        }),
        new TableCell({
          children: [new Paragraph("Access Restricted:")],
          shading: {
            fill: backgroundColorDelay
          }
        }),
        new TableCell({
          children: [new Paragraph(restrictedAccessWaterConveyance || "")],
          shading: {
            fill: backgroundColorDelay
          }
        }),

        new TableCell({
          children: [new Paragraph(restrictedAccessWaterConveyanceComments || "")],
          shading: {
            fill: backgroundColorDelay
          }
        }),
      ],
    }),
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("Surveillance:")],
          shading: {
            fill: backgroundColorDelay
          }
        }),
        new TableCell({
          children: [new Paragraph(surveillanceWaterConveyance || "")],
          shading: {
            fill: backgroundColorDelay
          }
        }),
        new TableCell({
          children: [new Paragraph(surveillanceWaterConveyanceComments || "")],
          shading: {
            fill: backgroundColorDelay
          }
        }),
      ],
      shading: {
        fill: backgroundColorDelay
      }
    }),
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("9. Is Critical Performance Monitoring Equipment (CPME) secured against tampering?")],
        shading: {
          fill: backgroundColorDelay
        }
    }),
    new TableCell({
      children: [new Paragraph(cpmeTamperResistant || "")],
      columnSpan: 2,
      shading: {
        fill: backgroundColorDelay
      }
    }),
    new TableCell({
      children: [new Paragraph(cpmeTamperResistantComments || "")],
      shading: {
        fill: backgroundColorDelay
      }
    }),
    ]
  }),
    // new TableRow({
    //   children: [
    //     new TableCell({
    //       children: [new Paragraph("9. Is Critical Performance Monitoring Equipment (CPME) secured against tampering? ")],
    //       shading: {
    //         fill: backgroundColorDelay
    //       }
    //   }),
    //   new TableCell({
    //     children: [new Paragraph(powerhouseSurveillanceCameras || "")],
    //     shading: {
    //       fill: backgroundColorDelay
    //     }
    //   }),
    //   new TableCell({
    //     children: [new Paragraph(powerhouseSurveillanceCamerasComments || "")],
    //     shading: {
    //       fill: backgroundColorDelay
    //     }
    //   }),
    //   ],
    // }),
  ],
  margins: {
    top: convertInchesToTwip(0.05),
    bottom: convertInchesToTwip(0.05),
    right: convertInchesToTwip(0.05),
    left: convertInchesToTwip(0.05),
},
});

// console.log(criticalAssetList);

// RESPONSE TABLE
const tableResponse = new Table({
  rows: [

    //********** TABLE HEADERS **************/
      new TableRow({
          children: [
              new TableCell({
                children: [new Paragraph("Field Observations: (Provide detailed supplemental information to the right)")],
              }),
              new TableCell({
                children: [new Paragraph("Answer")],
                columnSpan: 2,
              }),
              new TableCell({
                children: [new Paragraph("Comments (Provide additional details – especially any “No” answers – here and separate sheets, if necessary. Indicate NA if not appropriate to site.) ")],
              }),
              // new TableCell({
              //   children: [new Paragraph("Test cell 1.")],
              // }),
              // new TableCell({
              //   children: [new Paragraph("Test cell 1.")],
              // }),
          ], 
          
      }),

    //********** TABLE TITLE **************/
      new TableRow ({
        children: [ 
          new TableCell({
            children: [new Paragraph({text: "Response", heading: HeadingLevel.HEADING_3})],
            columnSpan: 4,
            shading: {
              fill: backgroundColorResponse
            }
          }),
          
        ]
      }),

    //********* 10 **********/
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("10. Are law enforcement phone numbers posted?")],
            shading: {
              fill: backgroundColorResponse
            }
        }),
        new TableCell({
          children: [new Paragraph(phoneNumbersLEPosted || "")],
          columnSpan: 2,
          shading: {
            fill: backgroundColorResponse
          }
        }),
        new TableCell({
          children: [
            new Paragraph(phoneNumbersLEPostedComments || ""),
          ],
          shading: {
            fill: backgroundColorResponse
          }
        }),
        ],
    }),

    //********* 11 **********/
      new TableRow({
          children: [
              new TableCell({
                  children: [
                    new Paragraph("11. Are there redundant communications?")
                  ],
                  // rowSpan: 3,
                  shading: {
                    fill: backgroundColorResponse
                  }
              }),
              new TableCell({
                children: [
                  new Paragraph(redundantComms || "")
                ],
                columnSpan: 2,
                shading: {
                  fill: backgroundColorResponse
                }
              }),
              new TableCell({
                children: [
                  new Paragraph(redundantCommsComments || "")
                ],
                shading: {
                  fill: backgroundColorResponse
                }
              }),
          ]
      }),

    //********* 12 **********/
      new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph("12. How long it takes the operator if detected to respond to unauthorized access?")],
              rowSpan: 3,
              columnSpan: 2,
              shading: {
                fill: backgroundColorResponse
              }
          }),
          new TableCell({
            children: [new Paragraph(operatorResponseTime || "")],
            columnSpan: 2,
            shading: {
              fill: backgroundColorResponse
            }
          }),
          
          ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("How is detection made?")],
            shading: {
              fill: backgroundColorResponse
            }
          }),
          new TableCell({
            children: [new Paragraph(operatorResponseTimeComments || "")],
            shading: {
              fill: backgroundColorResponse
            }
          }),
        ]
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("What is the response?")],
            shading: {
              fill: backgroundColorResponse
            }
          }),
          new TableCell({
            children: [new Paragraph(operatorResponseDescription || "")],
            shading: {
              fill: backgroundColorResponse
            }
          }),
        ]
      }),

    //********* 13 **********/
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("13. Can law enforcement be quickly notified? ")
            ],
            rowSpan: 3,
            columnSpan: 2,
            shading: {
              fill: backgroundColorResponse
            }
          }),
          new TableCell({
            children: [
              new Paragraph(quicklyNotifyLE || "")
            ],
            columnSpan: 2, 
            shading: {
              fill: backgroundColorResponse
            }
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph("Identify law enforcement agencies & capabilities:")
            ],
            shading: {
              fill: backgroundColorResponse
            }
          }),
          new TableCell({
            children: [
              new Paragraph(quicklyNotifyLEComments || "")
            ],
            shading: {
              fill: backgroundColorResponse
            }
          }),
          
        ],
    }),
    new TableRow({
      children: [
        new TableCell({
          children: [
            new Paragraph("Estimated time for arrival:")
          ],
          shading: {
            fill: backgroundColorResponse
          }
        }),
        new TableCell({
          children: [
            new Paragraph(etaLE || "")
          ],
          shading: {
            fill: backgroundColorResponse
          }
        }),
      ],
    }),
  ],
  margins: {
    top: convertInchesToTwip(0.05),
    bottom: convertInchesToTwip(0.05),
    right: convertInchesToTwip(0.05),
    left: convertInchesToTwip(0.05),
  },
});

// INTEGRATION AND RISK MANAGEMENT TABLE
const tableIntegrationRiskManagement = new Table({
  rows: [

    //********** TABLE HEADERS **************/
    new TableRow({
          children: [
              new TableCell({
                children: [new Paragraph("Field Observations: (Provide detailed supplemental information to the right)")],
              }),
              new TableCell({
                children: [new Paragraph("Answer")],
                columnSpan: 2,
              }),
              new TableCell({
                children: [new Paragraph("Comments (Provide additional details – especially any “No” answers – here and separate sheets, if necessary. Indicate NA if not appropriate to site.) ")],
              }),
          ], 
    }),

    //********** TABLE TITLE **************/
    new TableRow ({
        children: [ 
          new TableCell({
            children: [new Paragraph({text: "Integration and Risk Management", heading: HeadingLevel.HEADING_3})],
            columnSpan: 4,
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
          }),
          
        ]
    }),

    //********** 14a **************/
    new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("14a. Describe vulnerable features, including switchyards & transmission lines, etc., and potential impacts for each, include cyberattacks.")],
            columnSpan: 2,
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
        }),
        new TableCell({
          children: [new Paragraph(vulernableFeatures || "")],
          columnSpan: 2,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        ],
    }),

    //********** 14b **************/
    new TableRow({
          children: [
              new TableCell({
                  children: [
                    new Paragraph("14b. Describe threats your organization has identified.")
                  ],
                  // rowSpan: 3,
                  columnSpan: 2, 
                  shading: {
                    fill: backgroundColorIntegrationRiskManagement
                  }
              }),
              new TableCell({
                children: [
                  new Paragraph(threatAssessmentComments || "")
                ],
                columnSpan: 2,
                shading: {
                  fill: backgroundColorIntegrationRiskManagement
                }
              }),
          ]
    }),

    //********** 14c **************/
    new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("14c. Last time a consultation with law enforcement was made to determine threat:")],
            columnSpan: 2, 
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
          }),
          new TableCell({
            children: [new Paragraph(dateLastLEConsultation || "")],
            columnSpan: 2, 
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
          }),
        ]
    }),

    //********** 15a **************/
    new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph(`15a. Describe the steps or projects you have taken to improve security in the last year.`)
            ],
            columnSpan: 2,
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
          }),
          new TableCell({
            children: [
              new Paragraph(securityImprovementLastYear || "")
            ],
            columnSpan: 2, 
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
          }),
        ],
    }),

    //********** 15b **************/
    new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph("15b. If applicable, describe your long-term plans to improve security.")
            ],
            columnSpan: 2,
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
          }),
          new TableCell({
            children: [
              new Paragraph(securityImprovementLongTerm || "")
            ],
            columnSpan: 2, 
            shading: {
              fill: backgroundColorIntegrationRiskManagement
            }
          }),
          
        ],
    }),

    //********* 16a ***********//
    new TableRow({
      children: [
        new TableCell({
          borders: {
            bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
          },
          children: [
            // new Paragraph({
            //   children: [ 
            //     new TextRun("16a. Is there a Security Plan? (Group 1 or 2)"),
            //     new TextRun("Is the plan acceptable?"),
            //     new TextRun("Is there a Response/Recovery component?"),
            //     new TextRun("Are there different site-specific response levels covered in the Security Plan for varying threat?"),
            //     new TextRun("Are the measures on the day of inspection consistent with the current threat level?"),
            //   ],
            //   spacing: 5,
            // })
            new Paragraph("16a. Is there a Security Plan? (Group 1 or 2)"),
            // new Paragraph("Is the plan acceptable?"),
            // new Paragraph("Is there a Response/Recovery component?"),
            // new Paragraph("Are there different site-specific response levels covered in the Security Plan for varying threat?"),
            // new Paragraph("Are the measures on the day of inspection consistent with the current threat level?"),
          ],
          rowSpan: 1,
          colSpan: 3,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(hasSecurityPlan || "")
          ],
          columnSpan: 2,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(hasSecurityPlanComments || "")
          ],
          rowSpan: 3,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
      ],
    }),
    new TableRow({
      children: [
        new TableCell({
          borders: {
            top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
            bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
          },
          margins: {
            left: convertInchesToTwip(0.2),
          },
          children: [
            new Paragraph("Is the plan acceptable?")
          ],
          colSpan: 3,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(overallSecurityPlanQuality || "")
          ],
          columnSpan: 2, 
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
      ],
    }),
    new TableRow({
      children: [
        new TableCell({
          borders: {
            top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
            bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
          },
          margins: {
            left: convertInchesToTwip(0.2),
          },
          children: [
            new Paragraph("Is there a Response/Recovery component?")
          ],
          colSpan: 3,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(responseRecoveryPlan || "")
          ],
          columnSpan: 2, 
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
      ],
    }),
    new TableRow({
      children: [
        new TableCell({
          borders: {
            top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
            bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
          },
          margins: {
            left: convertInchesToTwip(0.2),
          },
          children: [
            new Paragraph("Are there different site-specific response levels covered in the Security Plan for varying threat?")
          ],
          colSpan: 2,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(siteSpecificResponseLevels || "")
          ],
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(siteSpecificResponseLevelsComments || "")
          ],
          columnSpan: 2,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
      ],
    }),
    new TableRow({
      children: [
        new TableCell({
          borders: {
            top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
            bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
          },
          margins: {
            left: convertInchesToTwip(0.2),
          },
          children: [
            new Paragraph("Are the measures on the day of inspection consistent with the current threat level?")
          ],
          colSpan: 2,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(currentandInspectionLevels || "")
          ],
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
        new TableCell({
          children: [
            new Paragraph(currentandInspectionLevelsComments || "")
          ],
          columnSpan: 2,
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
        }),
      ],
    }),

    // ******* 16b ******************* //
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("16b. Has the Security Plan been revised since the last field change?")],
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
      }),
      new TableCell({
        children: [new Paragraph(securityPlanRevision || "")],
        columnSpan: 2,
        shading: {
          fill: backgroundColorIntegrationRiskManagement
        }
      }),
      new TableCell({
        children: [
          new Paragraph("When was it last exercised & what type?"),
          new Paragraph(securityPlanRevisionComments || ""),
        ],
        shading: {
          fill: backgroundColorIntegrationRiskManagement
        }
      }),
      ],
    }),

    // ******* 17 ******************* //
    new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("17. Is there a Vulnerability Assessment? (Group 1)")],
        shading: {
          fill: backgroundColorIntegrationRiskManagement
        }
    }),
    new TableCell({
      children: [new Paragraph(hasVulnerabilityAssessment || "")],
      columnSpan: 2,
      shading: {
        fill: backgroundColorIntegrationRiskManagement
      }
    }),
    new TableCell({
      children: [
        new Paragraph("If YES is it compliant?"),
        new Paragraph(hasVulnerabilityAssessmentComments || ""),
      ],
      shading: {
        fill: backgroundColorIntegrationRiskManagement
      }
    }),
    ],
    }),

    // ******* 18 ******************* //
    new TableRow({
  children: [
    new TableCell({
      children: [new Paragraph("18. Is there a Security Assessment? (Group 2)")],
      shading: {
        fill: backgroundColorIntegrationRiskManagement
      }
  }),
  new TableCell({
    children: [new Paragraph(hasSecurityAssessment || "")],
    columnSpan: 2,
    shading: {
      fill: backgroundColorIntegrationRiskManagement
    }
  }),
  new TableCell({
    children: [
      new Paragraph("If YES is it compliant?"),
      new Paragraph(hasSecurityAssessmentComments || ""),
    ],
    shading: {
      fill: backgroundColorIntegrationRiskManagement
    }
  }),
  ],
    }),

    // ******* 19 ******************* //
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("19. Is there a Security Assessment? (Group 2)")],
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
      }),
      new TableCell({
        children: [new Paragraph(planActionIntegration || "")],
        columnSpan: 2,
        shading: {
          fill: backgroundColorIntegrationRiskManagement
        }
      }),
      new TableCell({
        children: [
          new Paragraph(planActionIntegrationComments || ""),
        ],
        shading: {
          fill: backgroundColorIntegrationRiskManagement
        }
      }),
      ],
    }),

    // ******* 20 ******************* //
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("20. Do any security measures conflict with any license requirements?")],
          shading: {
            fill: backgroundColorIntegrationRiskManagement
          }
      }),
      new TableCell({
        children: [new Paragraph(conflictingSecurityMeasures || "")],
        columnSpan: 2,
        shading: {
          fill: backgroundColorIntegrationRiskManagement
        }
      }),
      new TableCell({
        children: [
          new Paragraph(conflictingSecurityMeasuresComments || ""),
        ],
        shading: {
          fill: backgroundColorIntegrationRiskManagement
        }
      }),
      ],
    }),




    // end of TABLE
  ],
  margins: {
    top: convertInchesToTwip(0.05),
    bottom: convertInchesToTwip(0.05),
    right: convertInchesToTwip(0.05),
    left: convertInchesToTwip(0.05),
  },
});




  const table = new Table({
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph("Test cell 1.")],
                    shading: {
                      fill: "b79c2f",
                      color: "#333333",
                    }
                }),
            ],
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph("Test cell 2.")],
                    shading: {
                      fill: "b79c2f",
                      color: "#333333",
                    }
                }),
            ],
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph("Test cell 3.")],
                }),
            ],
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph("Test cell 4.")],
                }),
            ],
        }),
    ],
});

const doc = new Document({
    numbering: {
        config: [
            {
                reference: "ref1",
                levels: [
                    {
                        level: 0,
                        format: LevelFormat.DECIMAL,
                        text: "%1)",
                        start: 50,
                    },
                ],
            },
            {reference: "my-crazy-numbering",
              levels: [
                  {
                      level: 0,
                      format: LevelFormat.UPPER_ROMAN,
                      text: "%1",
                      alignment: AlignmentType.START,
                      style: {
                          paragraph: {
                              indent: { left: convertInchesToTwip(0.5), hanging: convertInchesToTwip(0.18) },
                          },
                      },
                  },
                  {
                      level: 1,
                      format: LevelFormat.DECIMAL,
                      text: "%2.",
                      alignment: AlignmentType.START,
                      style: {
                          paragraph: {
                              indent: { left: convertInchesToTwip(1), hanging: convertInchesToTwip(0.68) },
                          },
                      },
                  },
                  {
                      level: 2,
                      format: LevelFormat.LOWER_LETTER,
                      text: "%3)",
                      alignment: AlignmentType.START,
                      style: {
                          paragraph: {
                              indent: { left: convertInchesToTwip(1.5), hanging: convertInchesToTwip(1.18) },
                          },
                      },
                  },
                  {
                      level: 3,
                      format: LevelFormat.UPPER_LETTER,
                      text: "%4)",
                      alignment: AlignmentType.START,
                      style: {
                          paragraph: {
                              indent: { left: 2880, hanging: 2420 },
                          },
                      },
                  },
              ],
          },
            {
            reference: "my-unique-bullet-points",
            levels: [
                {
                    level: 0,
                    format: LevelFormat.BULLET,
                    text: "\u1F60",
                    alignment: AlignmentType.LEFT,
                    run: { font: "Calibri", size: 26 },
                    style: {
                        paragraph: {
                            indent: { left: convertInchesToTwip(0.5), hanging: convertInchesToTwip(0.25) },
                        },
                    },
                },
                {
                    level: 1,
                    format: LevelFormat.BULLET,
                    text: "\u00A5",
                    alignment: AlignmentType.LEFT,
                    style: {
                        paragraph: {
                            indent: { left: convertInchesToTwip(1), hanging: convertInchesToTwip(0.25) },
                        },
                    },
                },
                {
                    level: 2,
                    format: LevelFormat.BULLET,
                    text: "\u273F",
                    alignment: AlignmentType.LEFT,
                    style: {
                        paragraph: {
                            indent: { left: 2160, hanging: convertInchesToTwip(0.25) },
                        },
                    },
                },
                {
                    level: 3,
                    format: LevelFormat.BULLET,
                    text: "\u267A",
                    alignment: AlignmentType.LEFT,
                    style: {
                        paragraph: {
                            indent: { left: 2880, hanging: convertInchesToTwip(0.25) },
                        },
                    },
                },
                {
                    level: 4,
                    format: LevelFormat.BULLET,
                    text: "\u2603",
                    alignment: AlignmentType.LEFT,
                    style: {
                        paragraph: {
                            indent: { left: 3600, hanging: convertInchesToTwip(0.25) },
                        },
                    },
                },
            ],
          }
        ],
    },
    styles: {
        default: {
            heading1: {
                run: {
                    font: "Calibri",
                    size: 52,
                    bold: true,
                    color: "000000",
                    // underline: {
                    //     type: UnderlineType.SINGLE,
                    //     color: "000000",
                    // },
                },
                paragraph: {
                    alignment: AlignmentType.CENTER,
                    spacing: { line: 340 },
                },
            },
            heading2: {
                run: {
                    font: "Calibri",
                    size: 26,
                    // bold: true,
                    underline: {
                      type: UnderlineType.SINGLE,
                      color: "000000",
                  },
                },
                paragraph: {
                    spacing: { line: 340 },
                },
            },
            heading3: {
                run: {
                    font: "Calibri",
                    size: 26,
                    bold: true,
                },
                paragraph: {
                    spacing: { line: 276 },
                },
            },
            heading4: {
                run: {
                    font: "Calibri",
                    size: 26,
                    bold: true,
                },
                paragraph: {
                    alignment: AlignmentType.JUSTIFIED,
                    spacing: { line: 340 },
                },
            },
        },
        paragraphStyles: [
            {
                id: "normalPara",
                name: "Normal Para",
                basedOn: "Normal",
                next: "Normal",
                quickFormat: true,
                run: {
                    font: "Calibri",
                    size: 26,
                    bold: true,
                },
                paragraph: {
                    spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
                    rightTabStop: TabStopPosition.MAX,
                    leftTabStop: 453.543307087,
                },
            },
            {
                id: "normalPara2",
                name: "Normal Para2",
                basedOn: "Normal",
                next: "Normal",
                quickFormat: true,
                run: {
                    font: "Calibri",
                    size: 26,
                },
                paragraph: {
                    alignment: AlignmentType.JUSTIFIED,
                    spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
                },
            },
            {
                id: "aside",
                name: "Aside",
                basedOn: "Normal",
                next: "Normal",
                run: {
                    color: "999999",
                    italics: true,
                },
                paragraph: {
                    spacing: { line: 276 },
                    indent: { left: convertInchesToTwip(0.5) },
                },
            },
            {
                id: "wellSpaced",
                name: "Well Spaced",
                basedOn: "Normal",
                paragraph: {
                    spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
                },
            },
            {
                id: "numberedPara",
                name: "Numbered Para",
                basedOn: "Normal",
                next: "Normal",
                quickFormat: true,
                run: {
                    font: "Calibri",
                    size: 26,
                    bold: true,
                },
                paragraph: {
                    spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
                    // rightTabStop: TabStopPosition.MAX,
                    leftTabStop: 453.543307087,
                    numbering: {
                        reference: "ref1",
                        instance: 0,
                        level: 0,
                    },
                },
            },
        ],
    },



    // CONTENT BEGINS HERE:
    sections: [
        {
            properties: {
              type: SectionType.CONTINUOUS,
                page: {
                    margin: {
                      top: convertInchesToTwip(1),
                      bottom: convertInchesToTwip(1),
                      right: convertInchesToTwip(1),
                      left: convertInchesToTwip(1),
                    },
                    pageNumbers: {
                       start: 1,
                      formatType: NumberFormat.DECIMAL,
                    },
                },
            },
            footers: {
                default: new Footer({
                    children: [
                        new Paragraph({
                          alignment: AlignmentType.CENTER,
                          children: [
                            new TextRun({
                              children: [``, PageNumber.CURRENT],
                            }),
                          ],
                        }),
                    ],
                }),
            },
            children: [
                // new Paragraph({
                //     children: [
                //         new ImageRun({
                //             data: fs.readFileSync("./demo/images/pizza.gif"),
                //             transformation: {
                //                 width: 100,
                //                 height: 100,
                //             },
                //         }),
                //     ],
                // }),
                new Paragraph({
                  text: "SECURITY ASSESSMENT",
                  heading: HeadingLevel.HEADING_1,
                  alignment: AlignmentType.CENTER,
                }),
                // new Paragraph({
                //   text: `DAM: ${damName}      PROJECT: ${fercProject}
                //   UTILITY: ${utility}           REPORT DATE: ${todayDate}       VERSION: 1`,
                //   style: "wellSpaced",
                // }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({text: `DAM: ${damName}` })],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [new Paragraph({text: `PROJECT: [enter your project number]`})],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [new Paragraph({ text: `UTILITY: ${damData?.ownerNames}` })],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                      //   new TableCell({
                      //     children: [new Paragraph({ text: `UTILITY: ${utility}` })],
                      //     textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT,
                      // }),
                      //   new TableCell({
                      //       children: [new Paragraph({ text: "top to bottom" }), new Paragraph({})],
                      //       textDirection: TextDirection.TOP_TO_BOTTOM_RIGHT_TO_LEFT,
                      //   }),
                      ],
                    }),
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [
                              new Paragraph({
                                text: `REPORT DATE: ${todayDate}`,
                                // heading: HeadingLevel.HEADING_3,
                              }),
                            ],
                          }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              text: "VERSION: 1",
                            }),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                              // new TableCell({
                              //     children: [
                              //         new Paragraph({
                              //             text: "This text should be in the middle of the cell",
                              //         }),
                              //     ],
                              //     verticalAlign: VerticalAlign.CENTER,
                              // }),
                              // new TableCell({
                              //     children: [
                              //         new Paragraph({
                              //             text: "Text above should be vertical from bottom to top",
                              //         }),
                              //     ],
                              //     verticalAlign: VerticalAlign.CENTER,
                              // }),
                              // new TableCell({
                              //     children: [
                              //         new Paragraph({
                              //             text: "Text above should be vertical from top to bottom",
                              //         }),
                              //     ],
                              //     verticalAlign: VerticalAlign.CENTER,
                              // }),
                          ],
                      }),
                  ],
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  margins: {
                    top: convertInchesToTwip(0.05),
                    bottom: convertInchesToTwip(0.05),
                    right: convertInchesToTwip(0.05),
                    left: convertInchesToTwip(0.05),
                    style: "wellSpaced"
                },
              }),
            ]
          },
          // 1. INTRODUCTION
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: [
              new Paragraph({
                text: "1. INTRODUCTION",
                heading: HeadingLevel.HEADING_2,
              }),
              new Paragraph({
                text: `The ${damName} Dam (FERC Project No. [enter your project number] ) has been classified by the Federal Energy Regulatory Commission (FERC) as a ${assessmentData?.estimatedSecurityGroup} dam. The dam is located on the ${damData?.riverorStreamName} River, approximately ${damData?.distancetoNearestCityMiles} miles upstream from the city of ${damData?.city}, ${damData?.state} state. The Project produces [enter your project number] megawatts of electricity, serving more than [Enter the number of people served] people.`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: "Other benefits of the facility include: <ADD ADDITIONAL BENEFITS OF THIS PROJECT OR DELETE THIS PARAGRAPH>",
                style: "normalPara2",
              }),
              new Paragraph({
                text: `The Security Assessment (SA) for this dam was prepared by the ${damData?.ownerNames} Utility in accordance with the Division of Dam Safety and Inspections, FERC Security Program for Hydropower Projects - Revision 3 (August 31, 2015).`,
                style: "normalPara2",
              }),
            ]
          },
          // 2. METHODOLOGY & SCOPE
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: [
                new Paragraph({
                    text: "2. METHODOLOGY & SCOPE",
                    heading: HeadingLevel.HEADING_2,
                }),
                new Paragraph({
                    text: "The SA was completed using the FERC Hydro Security Inspection Form (version 5 – August 31, 2015), a critical asset spreadsheet (attached) and careful examination of the following:",
                    style: "normalPara2",
                }),
                // table2,
                new Paragraph({
                text: `Asset Evaluation`,
                bullet: {level: 0},
                style: "normalPara2"
                }),
                new Paragraph({
                text: `Geographic, demographic, and political environment`,
                bullet: {level: 0},
                style: "normalPara2"
                }),
                new Paragraph({
                text: `Visibility, notability, and accessibility`,
                bullet: {level: 0},
                style: "normalPara2"
                }),
                new Paragraph({
                text: `Existing security systems and measures`,
                bullet: {level: 0},
                style: "normalPara2"
                }),

                new Paragraph({
                    text: `The SA was conducted of the dam’s structure, assets, appurtenant structures, and SCADA systems. The SA includes review of detection, assessment, delay, response, integration, risk management, and protective measures. The list of assets considered to be of importance to the ${damName} is shown below.`,
                    style: "normalPara2",
                }),
                ]
          },
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: criticalAssetList,
          },
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: [
                // criticalAssetTable,
                // table,
                // new Paragraph({
                //     children: [
                //         new ImageRun({
                //             data: fs.readFileSync("./demo/images/pizza.gif"),
                //             transformation: {
                //                 width: 100,
                //                 height: 100,
                //             },
                //         }),
                //     ],
                // }),
              new Paragraph({
                text: "The following personnel participated in conducting the assessment:",
                style: "normalPara2",
              }),
              new Paragraph({
                text: `Plant System Operators`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Plant Maintenance`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Project Safety Engineers`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Security Division`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `EDIT THIS LIST AS NEEDED`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: ``,
                style: "normalPara2",
              }),
            ]
          },
          // 3. FACTS & CONSIDERATIONS
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: [  
              new Paragraph({
                text: "3. FACTS & CONSIDERATIONS",
                heading: HeadingLevel.HEADING_2,
              }),
              new Paragraph({
                text: `The Dam is visible and accessible from State Route __________ on the ___________ County side of the ____________ River, and from State Route ____________ on the __________ County side. 
                It is visible and accessible from both upstream and downstream sides of the _________ River. (Alter visibility/accessibility as necessary.`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `A “Visitor Center”, located on site and shown on the accompanying drawing, hosts approximately ___________ visitors per year.`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: ` The ${damData?.ownerNames}'s UTILITY SECURITY DIVISION manages a program of systems and measures that ensure protection of the Dam and Project. The Physical layout of site security features for the Dam is contained on drawings incorporated in the Physical Security Plan, which also includes potential routes of intrusion. These systems and measures include (alter as needed):`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `Guard posts (with barriers and "Tiger Teeth")--located at each access point`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Placement of fencing, barricades, and signage`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Placement of signage and buoy lines -- upstream and downstream of dam`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Credentials/electronic access badges for employees and approved contractors`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Screening process for contractors, vendors, and visitors`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Electronic barrier arms/doors`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Padlock and key control`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Security cameras with 24-hour, live monitoring`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Intrusion alarms with 24-hour monitoring`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Contracted security guard services`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Training & exercises`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Security policies and procedures`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `Suspicious Activity Incident Reporting`,
                bullet: {level: 0}
              }),
              new Paragraph({
                text: `EDIT THIS LIST AS NEEDED`,
                bullet: {level: 0}
              }),

              new Paragraph({
                text: `There is no history of attempted sabotage at this Project. There is no history of unauthorized intrusions. On rare occasions, there have been individuals who have attempted to trespass -- but they were immediately observed and intercepted. In each of these cases, there was no malice or criminal intent. There is no intelligence to suggest FERC Hydro Project [enter your project number] has been targeted for any type of attack. (Alter above as necessary. Discuss if trespass or theft has occurred; if so, does this point to any weaknesses in site security?)`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `The ${damData?.ownerNames} Utility has developed strong partnerships with local Law Enforcement Agencies (LEA), Fire, and EMS agencies. These agencies support the ${damData?.ownerNames} Utility through collaborative training & exercises, observation patrols, response to incidents, and proactive meetings. Coordination meetings with LEA generally occur at the following intervals: ___________.`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `Procedures are in place to alter site security as threat conditions change as is shown in the Security Plan for the ${damName} Dam.`,
                style: "normalPara2",
              }),
              new Paragraph({
              text: ``,
              style: "normalPara2",
              }),
            ]
          },
          // 4. RESULTS OF ASSESSMENT
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: [
              new Paragraph({
                text: "4. RESULTS OF ASSESSMENT",
                heading: HeadingLevel.HEADING_2,
              }),
              new Paragraph({
                text: `4.1 Results from Hydro Security Inspection Form:`,
                heading: HeadingLevel.HEADING_3,
              }),
              new Paragraph({
                text: `A review of the Hydro Security Inspection Form indicates that ____________. (Describe general observations from the form.)`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `4.2 Results from Project “Asset List” Assessment Spreadsheet:`,
                heading: HeadingLevel.HEADING_3,
              }),
              new Paragraph({
                text: `For each asset evaluated, a subjective ranking of each security element used to protect that asset was assigned as: 1 (Requires attention); 2 (Limited acceptability); 3 (Acceptable-under modification); 4 (Acceptable). Three general routes of intrusion were considered in the assessment (foot, land vehicle, and boat). A review of the Assessment Spreadsheet indicates that _____________. (Describe general observations.) `,
                style: "normalPara2",
              }),
              new Paragraph({
              text: `From this assessment, some assets have been shown to be in need of further consideration. It should be noted that a full risk analysis has not been completed for this project, and the level of protection necessary for identified assets may more accurately be dependent upon resultant consequences and overall risk. Table 2 shows the assets identified as not fully acceptable according to the criteria defined in Attachment 2.`,
              style: "normalPara2",
              }),
              ,
              new Paragraph({
                text: `Based on values assigned, each asset will receive a score of 11 (poor) to 44 (excellent). Asset security coverage values ranged from ${Math.min(...scoreListTemp)} to ${Math.max(...scoreListTemp)}, with an average foot entrance project score of ${footScore}, an average (land) vehicle entrance project score of ${vehicleScore}, and an average boat entrance project score of ${boatScore}.`,
                style: "normalPara2",
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                text: `Table 1. Physical Security Assessment.`,
              }),
              securityAssessmentToolResultsTable,
              new Paragraph({
                text: ``,
                style: "normalPara2",
              }),
              new Paragraph({
                text: ``,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `4.3 Relative Risk Scores:`,
                heading: HeadingLevel.HEADING_3,
              }),
              new Paragraph({
                text: `The vulnerability assessment is a formal document and provides an analysis of the factors that define full Security Risk. Specific attack scenarios are evaluated for each critical asset against four factors defined by FERC. These factors are consequences (C), threat (T), vulnerability (V), and likelihood (L).`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `Each factor is assigned a score of 1 through 10. The security (S) of the critical asset is assigned a score of 10 through 1. FERC's comparative risk equation, see Figure 1, was used to quantify the risk of each critical asset.`,
                style: "normalPara2",
              }),
              new Paragraph({
                  children: [
                    new ImageRun({
                      data: Buffer.from(imageBase64FERCEquation, "base64"),
                      transformation: {
                        width: 300,
                        height: 80,
                      },
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                text: `Figure 1. FERC's Recommended Comparative Risk Analysis Equation.`,
              }),
              new Paragraph({
                text: `ADD GENERAL SUMMARY OF FINDINGS.`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: ``,
                style: "normalPara2",
              }),
            ]
          },
          {
            properties: {
              page: {
                  size: {
                      orientation: PageOrientation.LANDSCAPE,
                  },
                }
            },
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                text: "Table 2. Physical Security Vulnerability Assessment",
              }),
              criticalAssetTableRelativeRiskScores,
            ]
          },
          {
            properties: {
              page: {
                  size: {
                      orientation: PageOrientation.PORTRAIT,
                  },
                }
            },
            children: [
              new Paragraph({
                text: ``,
                style: "normalPara2",
              }),
                new Paragraph({
                text: `4.4 Results from Cyber/SCADA Asset Assessment:`,
                heading: HeadingLevel.HEADING_3,
              }),
              new Paragraph({
                text: `ADD GENERAL SUMMARY OF CYBER/SCADA FINDINGS.`,
                style: "normalPara2",
              }),
            ].concat(...zoneData)
          },
          // {
          //   children: zoneData
          // },
          
          // 5. RECOMMENDATIONS
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: [
              new Paragraph({
                text: "5. RECOMMENDATIONS",
                heading: HeadingLevel.HEADING_2,
              }),
              new Paragraph({
                text: `From this Security Assessment, the following recommendations for site security are proposed. An indication of the priority assigned to each recommendation (Low, Medium, or High) and a plan and schedule to complete each recommendation is also provided.`,
                style: "normalPara2",
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                text: "Table 3. Corrective Actions.",
              }),
              correctiveActionsTable,
              new Paragraph({
                text: "Test",
                style: "normalPara2",
              }),
            ]
          },
          // 6. CONCLUSIONS
          {
            properties: {
              type: SectionType.CONTINUOUS,
            },
            children: [
              new Paragraph({
                text: "6. CONCLUSIONS",
                heading: HeadingLevel.HEADING_2,
              }),
              new Paragraph({
                text: `The ${damData?.ownerNames} Utility’s existing Security Program is sufficiently effective in reacting to potential adversaries – particularly, generic intruders who could attempt to gain access to the identified assets at the ${damName} Hydro Project. The ${damData?.ownerNames} Utility will continue to monitor, assess, and respond to its security needs as they change or evolve. (Revise Conclusions as necessary.)`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `Attachments:`,
                heading: HeadingLevel.HEADING_2,
              }),
              new Paragraph({
                text: "FERC Hydro Security Checklist(v5)",
                numbering: {
                  reference: "my-crazy-numbering",
                  level: 1,}
              }),
              new Paragraph({
                text: "FERC Assessment Form Definitions",
                numbering: {
                  reference: "my-crazy-numbering",
                  level: 1,}
              }),
              new Paragraph({
                text: "Drawing of Security Features Layout and Potential Routes of Intrusion can be found in the Physical Security Plan",
                numbering: {
                  reference: "my-crazy-numbering",
                  level: 1,}
              }),
            ]
          },
          // ATTACHMENT 1. FERC HYDRO SECURITY CHECKLIST (V5)
          {
            children: [   
              new Paragraph({
                text: "ATTACHMENT 1. FERC HYDRO SECURITY CHECKLIST(V5)",
                heading: HeadingLevel.HEADING_2,
                pageBreakBefore: true,
              }),
              new Paragraph({
                text: `DETECTION AND ASSESSMENT`,
                heading: HeadingLevel.HEADING_2,
              }),
              tableDetectionAssessment,
              // new Paragraph({
              //   text: `TESTING THE PROBLEM FOUND ON 4/25.`,
              //   style: "normalPara2",
              // }),


              new Paragraph({
                text: `DELAY`,
                heading: HeadingLevel.HEADING_2,
              }),
              tableDelay,
              new Paragraph({
                text: ``,
                style: "normalPara2",
              }),


              new Paragraph({
                text: `RESPONSE`,
                heading: HeadingLevel.HEADING_2,
              }),
              tableResponse,
              // new Paragraph({
              //   text: `TEST #2 for the PROBLEM FOUND ON 4/25.`,
              //   style: "normalPara2",
              // }),

              new Paragraph({
                text: `INTEGRATION AND RISK MANAGEMENT`,
                heading: HeadingLevel.HEADING_2,
              }),
              tableIntegrationRiskManagement,
              // new Paragraph({
              //   text: `TEST #3 for the PROBLEM FOUND ON 4/25.`,
              //   style: "normalPara2",
              // }),

              // new Paragraph({
              //   text: `PROJECT SECURITY SUMMARY INFORMATION - FORM 2`,
              //   heading: HeadingLevel.HEADING_2,
              // }),
              // tableProjectSecuritySummary,
              // new Paragraph({
              //   text: ``,
              //   style: "normalPara2",
              // }),
            ]
          },
          // ATTACHMENT 2. FERC Hydro Cyber/SCADA Security Checklist - Form 3
          {
            children: [
              new Paragraph({
                text: "ATTACHMENT 2. FERC HYDRO CYBER/SCADA SECURITY CHECKLIST - FORM 3",
                heading: HeadingLevel.HEADING_2,
              }),
              form3Table,
            ],
          },
          // ATTACHMENT 3. FERC ASSESSMENT FORM DEFINITIONS
          {
            children: [
              new Paragraph({
                text: "ATTACHMENT 3. FERC ASSESSMENT FORM DEFINITIONS",
                heading: HeadingLevel.HEADING_2,
              }),
              // new Paragraph({
              //   text: `TEST #4 for the PROBLEM FOUND ON 4/25.`,
              //   style: "normalPara2",
              // }),
              // new Paragraph({
              //   text: `TEST #5 for the PROBLEM FOUND ON 4/25.`,
              //   style: "normalPara2",
              // }),

              // new Paragraph({
              //     children: [
              //         new ImageRun({
              //             data: fs.readFileSync("FERCRiskEquationLong),
              //             transformation: {
              //                 width: 100,
              //                 height: 100,
              //             },
              //         }),
              //     ],
              // }),

              // new Paragraph({
              //     text: "Test 2",
              //     style: "normalPara2",
              // }),
              // new Paragraph({
              //     text: "Numbered paragraph that has numbering attached to custom styles",
              //     style: "numberedPara2",
              // }),
              // new Paragraph({
              //     text: "Numbered para would show up in the styles pane at Word",
              //     style: "numberedPara2",
              // }),
              // new Paragraph({
              //     text: "",
              //     style: "normalPara2",
              // }),

            ]
          },
          // ATTACHMENT 4. CYBER SECURITY ASSESSMENT
          {
            children: [ 
              new Paragraph({
                text: "ATTACHMENT 3. CYBER SECURITY ASSESSMENT",
                heading: HeadingLevel.HEADING_2,
              }),
              new Paragraph({
                text: `TEST #4 for the PROBLEM FOUND ON 4/25.`,
                style: "normalPara2",
              }),
              new Paragraph({
                text: `TEST #5 for the PROBLEM FOUND ON 4/25.`,
                style: "normalPara2",
              }),
            ],
          },
          {
            properties: {
              page: {
                  size: {
                      orientation: PageOrientation.LANDSCAPE,
                  },
                }
            },
            children: zoneDataForAppendix
          }
        ],
});



  const handleGenerateReport = async () => {
    const mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; 
      Packer.toBlob(doc).then(str => {
        str.slice(0, str.size, mimeType);
        saveAs(str, "AssessmentReport.docx");

  });
    // console.log("Handle Generate Report Called.")
  };


  // ***************** FOR DOWNLOADING A SIMPLE TEXT FILE ******************
  //   const a = document.querySelector('a');
  //   const test = "testing the blob thing."
  //   const file = new Blob([test], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  //   // const file = new Blob([test], { type: 'plain/text' });
  //   const url = URL.createObjectURL(file);
  //   console.log(url);
  //   a.href = url;
  //   a.download = "myFileNEW.txt";
  // const myBlob = new Blob([doc], { type: 'plain/text' });

  return (
    <Box>
      <Dialog
        open={zoneData.length===0}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title"> </DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
            <Typography variant='h2'>Loading...</Typography>
        </DialogContentText>
        </DialogContent>
      </Dialog>
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ display:'flex', justifyContent:'center', mt:'2rem' }}>
          <a><Button sx={{ mb: '0.5rem', fontSize: '30', p: '1rem' }} variant="contained" onClick={handleGenerateReport}>Download Report</Button></a>
        </Grid>
        <Grid item xs={12} sx={{ display:'flex', justifyContent:'center', mt:'1rem' }}>
          <Typography variant='h2'>
            Click the button above to download your assessment report.  You will need to add some details and review the document for accuracy. 
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ display:'flex', justifyContent:'center', mt:'3rem' }}>
          <Typography variant='h2'>
            If you have questions you can request assistance by completing the form below.
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{  mt:'2rem' }}>
          <WidgetWrapper>
            <GetHelp />
          </WidgetWrapper>
        </Grid>
          {/* <FullFeaturedCrudGridChecklist /> */}
        </Grid>
      {/* <AssessmentReport /> */}
    </Box>
  )
}

export default SiteSecurityAssessment